var _defs, _g, _g2, _path, _path2, _circle, _circle2, _circle3, _circle4, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _rect2, _rect3, _path9, _path0, _path1, _path10, _path11, _rect4, _path12, _path13, _path14, _rect5, _path15, _rect6, _rect7, _rect8, _polygon, _path16, _circle5, _circle6, _circle7, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _polygon2, _polygon3, _rect9, _rect0, _path83, _path84, _path85, _ellipse, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _polygon4, _polygon5, _polygon6, _polygon7, _rect1, _rect10, _path93, _path94, _path95, _ellipse2, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _polygon8, _polygon9, _polygon0, _polygon1, _rect11, _rect12, _path103, _path104, _path105, _ellipse3, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path114, _g12, _path115, _g13, _g14, _g15, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItGovernance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 534 394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#a9a9ff;}.cls-3{fill:#877d62;}.cls-4{fill:#0f0670;}.cls-5{fill:#4e4655;}.cls-6{fill:#d7d7ff;}.cls-7{fill:#12087a;}.cls-8{fill:#91b9b8;}.cls-9{fill:#17282f;}.cls-10{fill:#0d0469;}.cls-11{fill:#170c88;}.cls-12{fill:#0e056d;}.cls-13{fill:#e5ecfd;}.cls-14{fill:#170d89;}.cls-15{fill:#4c73c0;}.cls-16{fill:#0f056e;}.cls-17{fill:#2d8e70;}.cls-18{fill:#0b0263;}.cls-19{fill:#dfe7fe;}.cls-20{fill:#0e046b;}.cls-21{fill:#dbe4fe;}.cls-22{fill:#0b0264;}.cls-23{fill:#0f056f;}.cls-24{fill:#190e8f;}.cls-25{fill:#e6ecfd;}.cls-26{fill:#0c0265;}.cls-27{fill:#0c0366;}.cls-28{fill:#160c86;}.cls-29{fill:#100673;}.cls-30{fill:#180d8a;}.cls-31{fill:#110774;}.cls-32{fill:#b4a7de;}.cls-33{fill:#140a80;}.cls-34{clip-path:url(#clippath-11);}.cls-35{clip-path:url(#clippath-10);}.cls-36{fill:#09005d;}.cls-37{fill:#e8eefd;}.cls-38{fill:#ffcc7b;}.cls-39{fill:#b9cce5;}.cls-40{clip-path:url(#clippath-1);}.cls-41{clip-path:url(#clippath-3);}.cls-42{clip-path:url(#clippath-4);}.cls-43{clip-path:url(#clippath-2);}.cls-44{clip-path:url(#clippath-7);}.cls-45{clip-path:url(#clippath-6);}.cls-46{clip-path:url(#clippath-9);}.cls-47{clip-path:url(#clippath-8);}.cls-48{clip-path:url(#clippath-5);}.cls-49{fill:#150b82;}.cls-50{fill:#140a7f;}.cls-51{fill:#1a0f91;}.cls-52{fill:#170c87;}.cls-53{fill:#190e8d;}.cls-54{fill:#160b84;}.cls-55,.cls-56,.cls-57{fill:#fff;}.cls-58{fill:#55c955;}.cls-59{fill:#120878;}.cls-60{fill:#dde9ff;}.cls-61{fill:#e9effd;}.cls-62{fill:#09005e;}.cls-63{fill:#dce5fe;}.cls-56{stroke-width:.2px;}.cls-56,.cls-57{stroke:#000;stroke-miterlimit:10;}.cls-64{fill:#13097d;}.cls-57{stroke-width:.5px;}.cls-65{fill:#110775;}.cls-66{fill:#0a015f;}.cls-67{fill:#0b0162;}.cls-68{fill:#13097c;}.cls-69{fill:#5c5062;}.cls-70{opacity:.42;}.cls-71{opacity:.4;}.cls-72{opacity:.5;}.cls-73{fill:#110776;}.cls-74{fill:#85b8e6;}.cls-75{fill:#0a0161;}.cls-76{fill:#14097e;}.cls-77{fill:#dee6fe;}.cls-78{fill:#0a0160;}.cls-79{fill:#13097b;}.cls-80{fill:#e4ebfd;}.cls-81{fill:#160b85;}.cls-82{fill:#0c0367;}.cls-83{fill:#0d0368;}.cls-84{fill:#120879;}.cls-85{fill:#0e046c;}.cls-86{fill:#f95e5e;}.cls-87{fill:#dde6fe;}.cls-88{fill:#150a81;}.cls-89{fill:#100671;}.cls-90{fill:#190e8e;}.cls-91{fill:#add3d2;}.cls-92{fill:#100672;}.cls-93{fill:#e0e8fe;}.cls-94{fill:#2ba17f;}.cls-95{fill:#ffb62d;}.cls-96{fill:#180d8b;}.cls-97{fill:#180e8c;}.cls-98{clip-path:url(#clippath);}.cls-99{fill:#e3eafd;}.cls-100{fill:#150b83;}.cls-101{fill:#3a3ae0;}.cls-102{fill:#1a0f90;}.cls-103{fill:#e7edfd;}.cls-104{fill:#dae3fe;}.cls-105{fill:#e2e9fe;}.cls-106{fill:#0d046a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.35,122.59c-.44,0-.8-.36-.8-.8v-20.19c0-.44.36-.8.8-.8s.8.36.8.8v20.19c0,.44-.36.8-.8.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "261.24 118.61 257.98 124.26 254.72 118.61 261.24 118.61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.35,197.5c-.44,0-.8-.36-.8-.8v-14.87c0-.44.36-.8.8-.8s.8.36.8.8v14.87c0,.44-.36.8-.8.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "261.24 193.51 257.98 199.16 254.72 193.51 261.24 193.51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.28,269.21c-.44,0-.8-.36-.8-.8v-19.66c0-.44.36-.8.8-.8s.8.36.8.8v19.66c0,.44-.36.8-.8.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "260.43 265.23 257.16 270.88 253.9 265.23 260.43 265.23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.57,192.18c-.44,0-.8-.36-.8-.8v-37.98c0-.44.36-.8.8-.8h43.83c.44,0,.8.36.8.8s-.36.8-.8.8h-43.03v37.19c0,.44-.36.8-.8.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.47 190.86 185.2 196.51 181.94 190.86 188.47 190.86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.66,192.18c-.44,0-.8-.36-.8-.8v-37.19h-43.03c-.44,0-.8-.36-.8-.8s.36-.8.8-.8h43.83c.44,0,.8.36.8.8v37.98c0,.44-.36.8-.8.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "328.48 190.86 331.75 196.51 335.01 190.86 328.48 190.86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.12,249.29h-146.09c-.44,0-.8-.36-.8-.8v-14.08c0-.44.36-.8.8-.8s.8.36.8.8v13.28h144.5v-13.28c0-.44.36-.8.8-.8s.8.36.8.8v14.08c0,.44-.36.8-.8.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 112.29,
    cy: 270.88,
    rx: 35.72,
    ry: 35.08,
    transform: "translate(-41.07 20.95) rotate(-9.02)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M84.25,69.34c28.12,12.2,188.89,89.87,143.1,253.81,0,0-119-23.89-146.71-251.13-.24-1.99,1.77-3.48,3.61-2.69Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M99.63,96.01c6.76,7.1,13.36,14.33,19.9,21.62,6.54,7.29,12.99,14.66,19.36,22.1,12.73,14.88,25.14,30.05,37.06,45.6,11.92,15.55,23.39,31.46,33.97,47.97,5.32,8.24,10.34,16.67,15.04,25.3,4.68,8.63,9.03,17.46,12.67,26.61.22.55-.05,1.16-.6,1.38-.55.22-1.16-.05-1.38-.6h0s0,0,0,0c-3.55-9.07-7.82-17.85-12.43-26.45-4.62-8.59-9.58-17.02-14.83-25.26-10.46-16.51-21.83-32.45-33.64-48.03-11.83-15.58-24.14-30.8-36.78-45.73-6.32-7.47-12.73-14.86-19.22-22.18-6.5-7.32-13.06-14.58-19.76-21.7h0c-.17-.18-.16-.47.02-.64.18-.17.46-.16.63.02Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M379.67,36.55c-2.09-2.15-4.97-3.37-7.97-3.37l-227.46.13c-3,0-5.88,1.22-7.97,3.38-2.09,2.16-3.22,5.07-3.12,8.07l9.02,290.57c.19,6,5.1,10.64,11.1,10.64h209.91c6.01,0,10.92-4.66,11.1-10.66l8.54-290.76c.09-3-1.04-5.85-3.14-8.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M369.61,49.92c-1.91-1.97-4.54-3.08-7.29-3.08l-207.9.12c-2.75,0-5.37,1.12-7.28,3.09-1.91,1.97-2.94,4.63-2.86,7.38l8.24,265.55c.17,5.48,4.66,9.72,10.14,9.72h191.86c5.49,0,9.98-4.25,10.15-9.74l7.8-265.73c.08-2.74-.95-5.34-2.87-7.31Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 257.98,
    cy: 75.99,
    r: 22.49,
    transform: "translate(137.18 316.27) rotate(-79.72)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 258.51,
    cy: 75.99,
    r: 20.9,
    transform: "translate(137.62 316.79) rotate(-79.72)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 257.98,
    cy: 298.04,
    r: 22.49,
    transform: "translate(-81.31 498.71) rotate(-79.72)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 258.51,
    cy: 298.04,
    r: 20.9,
    transform: "translate(-65.96 522.49) rotate(-83.74)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 239.62,
    y: 135.27,
    width: 36.72,
    height: 36.72,
    transform: "translate(-33.25 226.7) rotate(-44.86)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M350.51,216.89c0,7.92-6.42,14.34-14.34,14.34h-18.59c-7.92,0-14.34-6.42-14.34-14.34h0c0-7.92,6.42-14.34,14.34-14.34h18.59c7.92,0,14.34,6.42,14.34,14.34h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M348.56,216.89c0,7.41-5.91,13.28-13.2,13.28h-17.26c-7.29,0-13.2-5.87-13.2-13.28h0c0-7.41,5.91-13.28,13.2-13.28h17.26c7.29,0,13.2,5.87,13.2,13.28h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M281.99,216.89c0,7.92-6.42,14.34-14.34,14.34h-18.59c-7.92,0-14.34-6.42-14.34-14.34h0c0-7.92,6.42-14.34,14.34-14.34h18.59c7.92,0,14.34,6.42,14.34,14.34h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M280.03,216.89c0,7.41-5.91,13.28-13.2,13.28h-17.26c-7.29,0-13.2-5.87-13.2-13.28h0c0-7.41,5.91-13.28,13.2-13.28h17.26c7.29,0,13.2,5.87,13.2,13.28h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M211.86,216.89c0,7.92-6.42,14.34-14.34,14.34h-18.59c-7.92,0-14.34-6.42-14.34-14.34h0c0-7.92,6.42-14.34,14.34-14.34h18.59c7.92,0,14.34,6.42,14.34,14.34h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M209.9,216.89c0,7.41-5.91,13.28-13.2,13.28h-17.26c-7.29,0-13.2-5.87-13.2-13.28h0c0-7.41,5.91-13.28,13.2-13.28h17.26c7.29,0,13.2,5.87,13.2,13.28h0Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "258.53 122.59 259.14 122.3 259.14 122.59 258.53 122.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "257.64 122.59 259.14 121.88 259.14 122.3 258.53 122.59 257.64 122.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "257.55 122.21 259.14 121.45 259.14 121.88 257.64 122.59 257.55 122.59 257.55 122.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "257.55 121.79 259.14 121.03 259.14 121.45 257.55 122.21 257.55 121.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "257.55 121.37 259.14 120.61 259.14 121.03 257.55 121.79 257.55 121.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "257.55 120.95 259.14 120.19 259.14 120.61 257.55 121.37 257.55 120.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "257.55 120.52 259.14 119.77 259.14 120.19 257.55 120.95 257.55 120.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "257.55 120.1 259.14 119.34 259.14 119.77 257.55 120.52 257.55 120.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "257.55 119.68 259.14 118.92 259.14 119.34 257.55 120.1 257.55 119.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "257.55 119.26 259.14 118.5 259.14 118.92 257.55 119.68 257.55 119.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "257.55 118.84 259.14 118.08 259.14 118.5 257.55 119.26 257.55 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "257.55 118.41 259.14 117.66 259.14 118.08 257.55 118.84 257.55 118.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "257.55 117.99 259.14 117.23 259.14 117.66 257.55 118.41 257.55 117.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "257.55 117.57 259.14 116.81 259.14 117.23 257.55 117.99 257.55 117.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "257.55 117.15 259.14 116.39 259.14 116.81 257.55 117.57 257.55 117.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "257.55 116.72 259.14 115.97 259.14 116.39 257.55 117.15 257.55 116.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "257.55 116.3 259.14 115.54 259.14 115.97 257.55 116.72 257.55 116.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "257.55 115.88 259.14 115.12 259.14 115.54 257.55 116.3 257.55 115.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "257.55 115.46 259.14 114.7 259.14 115.12 257.55 115.88 257.55 115.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "257.55 115.04 259.14 114.28 259.14 114.7 257.55 115.46 257.55 115.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "257.55 114.61 259.14 113.86 259.14 114.28 257.55 115.04 257.55 114.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "257.55 114.19 259.14 113.43 259.14 113.86 257.55 114.61 257.55 114.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "257.55 113.77 259.14 113.01 259.14 113.43 257.55 114.19 257.55 113.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "257.55 113.35 259.14 112.59 259.14 113.01 257.55 113.77 257.55 113.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "257.55 112.93 259.14 112.17 259.14 112.59 257.55 113.35 257.55 112.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "257.55 112.5 259.14 111.75 259.14 112.17 257.55 112.93 257.55 112.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "257.55 112.08 259.14 111.32 259.14 111.75 257.55 112.5 257.55 112.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "257.55 111.66 259.14 110.9 259.14 111.32 257.55 112.08 257.55 111.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "257.55 111.24 259.14 110.48 259.14 110.9 257.55 111.66 257.55 111.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "257.55 110.81 259.14 110.06 259.14 110.48 257.55 111.24 257.55 110.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "257.55 110.39 259.14 109.63 259.14 110.06 257.55 110.81 257.55 110.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "257.55 109.97 259.14 109.21 259.14 109.63 257.55 110.39 257.55 109.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "257.55 109.55 259.14 108.79 259.14 109.21 257.55 109.97 257.55 109.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "257.55 109.13 259.14 108.37 259.14 108.79 257.55 109.55 257.55 109.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "257.55 108.7 259.14 107.95 259.14 108.37 257.55 109.13 257.55 108.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "257.55 108.28 259.14 107.52 259.14 107.95 257.55 108.7 257.55 108.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "257.55 107.86 259.14 107.1 259.14 107.52 257.55 108.28 257.55 107.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "257.55 107.44 259.14 106.68 259.14 107.1 257.55 107.86 257.55 107.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "257.55 107.02 259.14 106.26 259.14 106.68 257.55 107.44 257.55 107.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "257.55 106.59 259.14 105.84 259.14 106.26 257.55 107.02 257.55 106.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "257.55 106.17 259.14 105.41 259.14 105.84 257.55 106.59 257.55 106.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "257.55 105.75 259.14 104.99 259.14 105.41 257.55 106.17 257.55 105.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "257.55 105.33 259.14 104.57 259.14 104.99 257.55 105.75 257.55 105.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "257.55 104.9 259.14 104.15 259.14 104.57 257.55 105.33 257.55 104.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "257.55 104.48 259.14 103.72 259.14 104.15 257.55 104.9 257.55 104.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "257.55 104.06 259.14 103.3 259.14 103.72 257.55 104.48 257.55 104.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "257.55 103.64 259.14 102.88 259.14 103.3 257.55 104.06 257.55 103.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "257.55 103.22 259.14 102.46 259.14 102.88 257.55 103.64 257.55 103.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "257.55 102.79 259.14 102.04 259.14 102.46 257.55 103.22 257.55 102.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "257.55 102.37 259.14 101.61 259.14 102.04 257.55 102.79 257.55 102.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "257.55 101.95 259.14 101.19 259.14 101.61 257.55 102.37 257.55 101.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "257.55 101.53 259.05 100.81 259.14 100.81 259.14 101.19 257.55 101.95 257.55 101.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "257.55 101.11 258.17 100.81 259.05 100.81 257.55 101.53 257.55 101.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "258.17 100.81 257.55 101.11 257.55 100.81 258.17 100.81"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "254.72 118.61 257.41 124.26 254.72 124.26 254.72 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "254.84 118.61 257.53 124.26 257.41 124.26 254.72 118.61 254.84 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "254.97 118.61 257.66 124.26 257.53 124.26 254.84 118.61 254.97 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "255.09 118.61 257.78 124.26 257.66 124.26 254.97 118.61 255.09 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "255.22 118.61 257.91 124.26 257.78 124.26 255.09 118.61 255.22 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "255.35 118.61 258.03 124.26 257.91 124.26 255.22 118.61 255.35 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "255.47 118.61 258.16 124.26 258.03 124.26 255.35 118.61 255.47 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "255.6 118.61 258.29 124.26 258.16 124.26 255.47 118.61 255.6 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "255.72 118.61 258.41 124.26 258.29 124.26 255.6 118.61 255.72 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "255.85 118.61 258.54 124.26 258.41 124.26 255.72 118.61 255.85 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "255.97 118.61 258.66 124.26 258.54 124.26 255.85 118.61 255.97 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "256.1 118.61 258.79 124.26 258.66 124.26 255.97 118.61 256.1 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "256.22 118.61 258.91 124.26 258.79 124.26 256.1 118.61 256.22 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "256.35 118.61 259.04 124.26 258.91 124.26 256.22 118.61 256.35 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "256.48 118.61 259.16 124.26 259.04 124.26 256.35 118.61 256.48 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "256.6 118.61 259.29 124.26 259.16 124.26 256.48 118.61 256.6 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "256.73 118.61 259.41 124.26 259.29 124.26 256.6 118.61 256.73 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "256.85 118.61 259.54 124.26 259.41 124.26 256.73 118.61 256.85 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "256.98 118.61 259.67 124.26 259.54 124.26 256.85 118.61 256.98 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "257.1 118.61 259.79 124.26 259.67 124.26 256.98 118.61 257.1 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "257.23 118.61 259.92 124.26 259.79 124.26 257.1 118.61 257.23 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "257.35 118.61 260.04 124.26 259.92 124.26 257.23 118.61 257.35 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "257.48 118.61 260.16 124.24 260.11 124.26 260.04 124.26 257.35 118.61 257.48 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "257.6 118.61 260.26 124.19 260.16 124.24 257.48 118.61 257.6 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "257.73 118.61 260.36 124.14 260.26 124.19 257.6 118.61 257.73 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "257.86 118.61 260.46 124.09 260.36 124.14 257.73 118.61 257.86 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "257.98 118.61 260.57 124.04 260.46 124.09 257.86 118.61 257.98 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "258.11 118.61 260.67 124 260.57 124.04 257.98 118.61 258.11 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "258.23 118.61 260.77 123.95 260.67 124 258.11 118.61 258.23 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "258.36 118.61 260.87 123.9 260.77 123.95 258.23 118.61 258.36 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "258.48 118.61 260.98 123.85 260.87 123.9 258.36 118.61 258.48 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "258.61 118.61 261.08 123.8 260.98 123.85 258.48 118.61 258.61 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "258.73 118.61 261.18 123.75 261.08 123.8 258.61 118.61 258.73 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "258.86 118.61 261.24 123.62 261.24 123.72 261.18 123.75 258.73 118.61 258.86 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "258.99 118.61 261.24 123.36 261.24 123.62 258.86 118.61 258.99 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "259.11 118.61 261.24 123.09 261.24 123.36 258.99 118.61 259.11 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "259.24 118.61 261.24 122.83 261.24 123.09 259.11 118.61 259.24 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "259.36 118.61 261.24 122.57 261.24 122.83 259.24 118.61 259.36 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "259.49 118.61 261.24 122.3 261.24 122.57 259.36 118.61 259.49 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "259.61 118.61 261.24 122.04 261.24 122.3 259.49 118.61 259.61 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "259.74 118.61 261.24 121.77 261.24 122.04 259.61 118.61 259.74 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "259.86 118.61 261.24 121.51 261.24 121.77 259.74 118.61 259.86 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "259.99 118.61 261.24 121.25 261.24 121.51 259.86 118.61 259.99 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "260.11 118.61 261.24 120.98 261.24 121.25 259.99 118.61 260.11 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "260.24 118.61 261.24 120.72 261.24 120.98 260.11 118.61 260.24 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "260.37 118.61 261.24 120.46 261.24 120.72 260.24 118.61 260.37 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "260.49 118.61 261.24 120.19 261.24 120.46 260.37 118.61 260.49 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "260.62 118.61 261.24 119.93 261.24 120.19 260.49 118.61 260.62 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "260.74 118.61 261.24 119.66 261.24 119.93 260.62 118.61 260.74 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "260.87 118.61 261.24 119.4 261.24 119.66 260.74 118.61 260.87 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "260.99 118.61 261.24 119.14 261.24 119.4 260.87 118.61 260.99 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "261.12 118.61 261.24 118.87 261.24 119.14 260.99 118.61 261.12 118.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "261.24 118.87 261.12 118.61 261.24 118.61 261.24 118.87"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "258.53 197.5 259.14 197.2 259.14 197.5 258.53 197.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "257.85 197.5 259.14 196.88 259.14 197.2 258.53 197.5 257.85 197.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "257.55 197.32 259.14 196.56 259.14 196.88 257.85 197.5 257.55 197.5 257.55 197.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "257.55 197 259.14 196.24 259.14 196.56 257.55 197.32 257.55 197"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "257.55 196.68 259.14 195.92 259.14 196.24 257.55 197 257.55 196.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "257.55 196.36 259.14 195.6 259.14 195.92 257.55 196.68 257.55 196.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "257.55 196.04 259.14 195.28 259.14 195.6 257.55 196.36 257.55 196.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "257.55 195.72 259.14 194.96 259.14 195.28 257.55 196.04 257.55 195.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "257.55 195.4 259.14 194.64 259.14 194.96 257.55 195.72 257.55 195.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "257.55 195.08 259.14 194.32 259.14 194.64 257.55 195.4 257.55 195.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "257.55 194.76 259.14 194 259.14 194.32 257.55 195.08 257.55 194.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "257.55 194.44 259.14 193.68 259.14 194 257.55 194.76 257.55 194.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "257.55 194.12 259.14 193.36 259.14 193.68 257.55 194.44 257.55 194.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "257.55 193.8 259.14 193.04 259.14 193.36 257.55 194.12 257.55 193.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "257.55 193.48 259.14 192.72 259.14 193.04 257.55 193.8 257.55 193.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "257.55 193.16 259.14 192.4 259.14 192.72 257.55 193.48 257.55 193.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "257.55 192.84 259.14 192.08 259.14 192.4 257.55 193.16 257.55 192.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "257.55 192.52 259.14 191.76 259.14 192.08 257.55 192.84 257.55 192.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "257.55 192.2 259.14 191.44 259.14 191.76 257.55 192.52 257.55 192.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "257.55 191.88 259.14 191.12 259.14 191.44 257.55 192.2 257.55 191.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "257.55 191.56 259.14 190.8 259.14 191.12 257.55 191.88 257.55 191.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "257.55 191.24 259.14 190.48 259.14 190.8 257.55 191.56 257.55 191.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "257.55 190.92 259.14 190.16 259.14 190.48 257.55 191.24 257.55 190.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "257.55 190.6 259.14 189.84 259.14 190.16 257.55 190.92 257.55 190.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "257.55 190.28 259.14 189.52 259.14 189.84 257.55 190.6 257.55 190.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "257.55 189.96 259.14 189.2 259.14 189.52 257.55 190.28 257.55 189.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "257.55 189.64 259.14 188.88 259.14 189.2 257.55 189.96 257.55 189.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "257.55 189.32 259.14 188.56 259.14 188.88 257.55 189.64 257.55 189.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "257.55 189 259.14 188.24 259.14 188.56 257.55 189.32 257.55 189"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "257.55 188.68 259.14 187.92 259.14 188.24 257.55 189 257.55 188.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "257.55 188.36 259.14 187.6 259.14 187.92 257.55 188.68 257.55 188.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "257.55 188.04 259.14 187.28 259.14 187.6 257.55 188.36 257.55 188.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "257.55 187.72 259.14 186.96 259.14 187.28 257.55 188.04 257.55 187.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "257.55 187.4 259.14 186.64 259.14 186.96 257.55 187.72 257.55 187.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "257.55 187.08 259.14 186.32 259.14 186.64 257.55 187.4 257.55 187.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "257.55 186.76 259.14 186 259.14 186.32 257.55 187.08 257.55 186.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "257.55 186.44 259.14 185.68 259.14 186 257.55 186.76 257.55 186.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "257.55 186.12 259.14 185.36 259.14 185.68 257.55 186.44 257.55 186.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "257.55 185.8 259.14 185.04 259.14 185.36 257.55 186.12 257.55 185.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "257.55 185.48 259.14 184.72 259.14 185.04 257.55 185.8 257.55 185.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "257.55 185.16 259.14 184.4 259.14 184.72 257.55 185.48 257.55 185.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "257.55 184.84 259.14 184.08 259.14 184.4 257.55 185.16 257.55 184.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "257.55 184.52 259.14 183.76 259.14 184.08 257.55 184.84 257.55 184.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "257.55 184.2 259.14 183.44 259.14 183.76 257.55 184.52 257.55 184.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "257.55 183.88 259.14 183.12 259.14 183.44 257.55 184.2 257.55 183.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "257.55 183.56 259.14 182.8 259.14 183.12 257.55 183.88 257.55 183.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "257.55 183.24 259.14 182.48 259.14 182.8 257.55 183.56 257.55 183.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "257.55 182.92 259.14 182.16 259.14 182.48 257.55 183.24 257.55 182.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "257.55 182.6 259.14 181.84 259.14 182.16 257.55 182.92 257.55 182.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "257.55 182.28 259.14 181.52 259.14 181.84 257.55 182.6 257.55 182.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "257.55 181.96 259.14 181.2 259.14 181.52 257.55 182.28 257.55 181.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "257.55 181.64 258.84 181.03 259.14 181.03 259.14 181.2 257.55 181.96 257.55 181.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "257.55 181.32 258.17 181.03 258.84 181.03 257.55 181.64 257.55 181.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "258.17 181.03 257.55 181.32 257.55 181.03 258.17 181.03"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "254.72 193.51 257.41 199.16 254.72 199.16 254.72 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "254.84 193.51 257.53 199.16 257.41 199.16 254.72 193.51 254.84 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "254.97 193.51 257.66 199.16 257.53 199.16 254.84 193.51 254.97 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "255.09 193.51 257.78 199.16 257.66 199.16 254.97 193.51 255.09 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "255.22 193.51 257.91 199.16 257.78 199.16 255.09 193.51 255.22 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "255.35 193.51 258.03 199.16 257.91 199.16 255.22 193.51 255.35 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "255.47 193.51 258.16 199.16 258.03 199.16 255.35 193.51 255.47 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "255.6 193.51 258.29 199.16 258.16 199.16 255.47 193.51 255.6 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "255.72 193.51 258.41 199.16 258.29 199.16 255.6 193.51 255.72 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "255.85 193.51 258.54 199.16 258.41 199.16 255.72 193.51 255.85 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "255.97 193.51 258.66 199.16 258.54 199.16 255.85 193.51 255.97 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "256.1 193.51 258.79 199.16 258.66 199.16 255.97 193.51 256.1 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "256.22 193.51 258.91 199.16 258.79 199.16 256.1 193.51 256.22 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "256.35 193.51 259.04 199.16 258.91 199.16 256.22 193.51 256.35 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "256.48 193.51 259.16 199.16 259.04 199.16 256.35 193.51 256.48 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "256.6 193.51 259.29 199.16 259.16 199.16 256.48 193.51 256.6 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "256.73 193.51 259.41 199.16 259.29 199.16 256.6 193.51 256.73 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "256.85 193.51 259.54 199.16 259.41 199.16 256.73 193.51 256.85 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "256.98 193.51 259.67 199.16 259.54 199.16 256.85 193.51 256.98 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "257.1 193.51 259.79 199.16 259.67 199.16 256.98 193.51 257.1 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "257.23 193.51 259.92 199.16 259.79 199.16 257.1 193.51 257.23 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "257.35 193.51 260.04 199.16 259.92 199.16 257.23 193.51 257.35 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "257.48 193.51 260.16 199.14 260.11 199.16 260.04 199.16 257.35 193.51 257.48 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "257.6 193.51 260.26 199.09 260.16 199.14 257.48 193.51 257.6 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "257.73 193.51 260.36 199.05 260.26 199.09 257.6 193.51 257.73 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "257.86 193.51 260.46 199 260.36 199.05 257.73 193.51 257.86 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "257.98 193.51 260.57 198.95 260.46 199 257.86 193.51 257.98 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "258.11 193.51 260.67 198.9 260.57 198.95 257.98 193.51 258.11 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "258.23 193.51 260.77 198.85 260.67 198.9 258.11 193.51 258.23 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "258.36 193.51 260.87 198.8 260.77 198.85 258.23 193.51 258.36 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "258.48 193.51 260.98 198.75 260.87 198.8 258.36 193.51 258.48 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "258.61 193.51 261.08 198.7 260.98 198.75 258.48 193.51 258.61 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "258.73 193.51 261.18 198.66 261.08 198.7 258.61 193.51 258.73 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "258.86 193.51 261.24 198.52 261.24 198.63 261.18 198.66 258.73 193.51 258.86 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "258.99 193.51 261.24 198.26 261.24 198.52 258.86 193.51 258.99 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "259.11 193.51 261.24 198 261.24 198.26 258.99 193.51 259.11 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "259.24 193.51 261.24 197.73 261.24 198 259.11 193.51 259.24 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "259.36 193.51 261.24 197.47 261.24 197.73 259.24 193.51 259.36 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "259.49 193.51 261.24 197.21 261.24 197.47 259.36 193.51 259.49 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "259.61 193.51 261.24 196.94 261.24 197.21 259.49 193.51 259.61 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "259.74 193.51 261.24 196.68 261.24 196.94 259.61 193.51 259.74 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "259.86 193.51 261.24 196.41 261.24 196.68 259.74 193.51 259.86 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "259.99 193.51 261.24 196.15 261.24 196.41 259.86 193.51 259.99 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "260.11 193.51 261.24 195.89 261.24 196.15 259.99 193.51 260.11 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "260.24 193.51 261.24 195.62 261.24 195.89 260.11 193.51 260.24 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "260.37 193.51 261.24 195.36 261.24 195.62 260.24 193.51 260.37 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "260.49 193.51 261.24 195.1 261.24 195.36 260.37 193.51 260.49 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "260.62 193.51 261.24 194.83 261.24 195.1 260.49 193.51 260.62 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "260.74 193.51 261.24 194.57 261.24 194.83 260.62 193.51 260.74 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "260.87 193.51 261.24 194.3 261.24 194.57 260.74 193.51 260.87 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "260.99 193.51 261.24 194.04 261.24 194.3 260.87 193.51 260.99 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "261.12 193.51 261.24 193.78 261.24 194.04 260.99 193.51 261.12 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "261.24 193.78 261.12 193.51 261.24 193.51 261.24 193.78"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "257.46 269.21 258.08 268.92 258.08 269.21 257.46 269.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "256.6 269.21 258.08 268.51 258.08 268.92 257.46 269.21 256.6 269.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "256.49 268.85 258.08 268.1 258.08 268.51 256.6 269.21 256.49 269.21 256.49 268.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "256.49 268.44 258.08 267.68 258.08 268.1 256.49 268.85 256.49 268.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "256.49 268.03 258.08 267.27 258.08 267.68 256.49 268.44 256.49 268.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "256.49 267.62 258.08 266.86 258.08 267.27 256.49 268.03 256.49 267.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "256.49 267.21 258.08 266.45 258.08 266.86 256.49 267.62 256.49 267.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "256.49 266.79 258.08 266.04 258.08 266.45 256.49 267.21 256.49 266.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "256.49 266.38 258.08 265.62 258.08 266.04 256.49 266.79 256.49 266.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "256.49 265.97 258.08 265.21 258.08 265.62 256.49 266.38 256.49 265.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "256.49 265.56 258.08 264.8 258.08 265.21 256.49 265.97 256.49 265.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "256.49 265.15 258.08 264.39 258.08 264.8 256.49 265.56 256.49 265.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "256.49 264.73 258.08 263.98 258.08 264.39 256.49 265.15 256.49 264.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "256.49 264.32 258.08 263.56 258.08 263.98 256.49 264.73 256.49 264.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "256.49 263.91 258.08 263.15 258.08 263.56 256.49 264.32 256.49 263.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "256.49 263.5 258.08 262.74 258.08 263.15 256.49 263.91 256.49 263.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "256.49 263.09 258.08 262.33 258.08 262.74 256.49 263.5 256.49 263.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "256.49 262.67 258.08 261.92 258.08 262.33 256.49 263.09 256.49 262.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "256.49 262.26 258.08 261.5 258.08 261.92 256.49 262.67 256.49 262.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "256.49 261.85 258.08 261.09 258.08 261.5 256.49 262.26 256.49 261.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "256.49 261.44 258.08 260.68 258.08 261.09 256.49 261.85 256.49 261.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "256.49 261.03 258.08 260.27 258.08 260.68 256.49 261.44 256.49 261.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "256.49 260.61 258.08 259.86 258.08 260.27 256.49 261.03 256.49 260.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "256.49 260.2 258.08 259.44 258.08 259.86 256.49 260.61 256.49 260.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "256.49 259.79 258.08 259.03 258.08 259.44 256.49 260.2 256.49 259.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "256.49 259.38 258.08 258.62 258.08 259.03 256.49 259.79 256.49 259.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "256.49 258.97 258.08 258.21 258.08 258.62 256.49 259.38 256.49 258.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "256.49 258.56 258.08 257.8 258.08 258.21 256.49 258.97 256.49 258.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "256.49 258.14 258.08 257.39 258.08 257.8 256.49 258.56 256.49 258.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "256.49 257.73 258.08 256.97 258.08 257.39 256.49 258.14 256.49 257.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "256.49 257.32 258.08 256.56 258.08 256.97 256.49 257.73 256.49 257.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "256.49 256.91 258.08 256.15 258.08 256.56 256.49 257.32 256.49 256.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "256.49 256.5 258.08 255.74 258.08 256.15 256.49 256.91 256.49 256.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "256.49 256.08 258.08 255.33 258.08 255.74 256.49 256.5 256.49 256.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "256.49 255.67 258.08 254.91 258.08 255.33 256.49 256.08 256.49 255.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "256.49 255.26 258.08 254.5 258.08 254.91 256.49 255.67 256.49 255.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "256.49 254.85 258.08 254.09 258.08 254.5 256.49 255.26 256.49 254.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "256.49 254.44 258.08 253.68 258.08 254.09 256.49 254.85 256.49 254.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "256.49 254.02 258.08 253.27 258.08 253.68 256.49 254.44 256.49 254.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "256.49 253.61 258.08 252.85 258.08 253.27 256.49 254.02 256.49 253.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "256.49 253.2 258.08 252.44 258.08 252.85 256.49 253.61 256.49 253.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "256.49 252.79 258.08 252.03 258.08 252.44 256.49 253.2 256.49 252.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "256.49 252.38 258.08 251.62 258.08 252.03 256.49 252.79 256.49 252.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "256.49 251.96 258.08 251.21 258.08 251.62 256.49 252.38 256.49 251.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "256.49 251.55 258.08 250.79 258.08 251.21 256.49 251.96 256.49 251.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "256.49 251.14 258.08 250.38 258.08 250.79 256.49 251.55 256.49 251.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "256.49 250.73 258.08 249.97 258.08 250.38 256.49 251.14 256.49 250.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "256.49 250.32 258.08 249.56 258.08 249.97 256.49 250.73 256.49 250.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "256.49 249.9 258.08 249.15 258.08 249.56 256.49 250.32 256.49 249.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "256.49 249.49 258.08 248.73 258.08 249.15 256.49 249.9 256.49 249.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "256.49 249.08 258.08 248.32 258.08 248.73 256.49 249.49 256.49 249.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "256.49 248.67 257.97 247.96 258.08 247.96 258.08 248.32 256.49 249.08 256.49 248.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "256.49 248.26 257.1 247.96 257.97 247.96 256.49 248.67 256.49 248.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "257.1 247.96 256.49 248.26 256.49 247.96 257.1 247.96"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "253.9 265.23 256.59 270.88 253.9 270.88 253.9 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "254.03 265.23 256.72 270.88 256.59 270.88 253.9 265.23 254.03 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "254.15 265.23 256.84 270.88 256.72 270.88 254.03 265.23 254.15 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "254.28 265.23 256.97 270.88 256.84 270.88 254.15 265.23 254.28 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "254.4 265.23 257.09 270.88 256.97 270.88 254.28 265.23 254.4 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "254.53 265.23 257.22 270.88 257.09 270.88 254.4 265.23 254.53 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "254.65 265.23 257.34 270.88 257.22 270.88 254.53 265.23 254.65 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "254.78 265.23 257.47 270.88 257.34 270.88 254.65 265.23 254.78 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "254.91 265.23 257.59 270.88 257.47 270.88 254.78 265.23 254.91 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "255.03 265.23 257.72 270.88 257.59 270.88 254.91 265.23 255.03 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "255.16 265.23 257.84 270.88 257.72 270.88 255.03 265.23 255.16 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "255.28 265.23 257.97 270.88 257.84 270.88 255.16 265.23 255.28 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "255.41 265.23 258.1 270.88 257.97 270.88 255.28 265.23 255.41 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "255.53 265.23 258.22 270.88 258.1 270.88 255.41 265.23 255.53 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "255.66 265.23 258.35 270.88 258.22 270.88 255.53 265.23 255.66 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "255.78 265.23 258.47 270.88 258.35 270.88 255.66 265.23 255.78 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "255.91 265.23 258.6 270.88 258.47 270.88 255.78 265.23 255.91 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "256.03 265.23 258.72 270.88 258.6 270.88 255.91 265.23 256.03 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "256.16 265.23 258.85 270.88 258.72 270.88 256.03 265.23 256.16 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "256.29 265.23 258.97 270.88 258.85 270.88 256.16 265.23 256.29 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "256.41 265.23 259.1 270.88 258.97 270.88 256.29 265.23 256.41 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "256.54 265.23 259.23 270.88 259.1 270.88 256.41 265.23 256.54 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "256.66 265.23 259.34 270.86 259.3 270.88 259.23 270.88 256.54 265.23 256.66 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "256.79 265.23 259.44 270.81 259.34 270.86 256.66 265.23 256.79 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "256.91 265.23 259.55 270.76 259.44 270.81 256.79 265.23 256.91 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "257.04 265.23 259.65 270.71 259.55 270.76 256.91 265.23 257.04 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "257.16 265.23 259.75 270.66 259.65 270.71 257.04 265.23 257.16 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "257.29 265.23 259.85 270.62 259.75 270.66 257.16 265.23 257.29 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "257.42 265.23 259.95 270.57 259.85 270.62 257.29 265.23 257.42 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "257.54 265.23 260.06 270.52 259.95 270.57 257.42 265.23 257.54 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "257.67 265.23 260.16 270.47 260.06 270.52 257.54 265.23 257.67 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "257.79 265.23 260.26 270.42 260.16 270.47 257.67 265.23 257.79 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "257.92 265.23 260.36 270.37 260.26 270.42 257.79 265.23 257.92 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "258.04 265.23 260.43 270.24 260.43 270.34 260.36 270.37 257.92 265.23 258.04 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "258.17 265.23 260.43 269.98 260.43 270.24 258.04 265.23 258.17 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "258.29 265.23 260.43 269.71 260.43 269.98 258.17 265.23 258.29 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "258.42 265.23 260.43 269.45 260.43 269.71 258.29 265.23 258.42 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "258.54 265.23 260.43 269.19 260.43 269.45 258.42 265.23 258.54 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "258.67 265.23 260.43 268.92 260.43 269.19 258.54 265.23 258.67 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "258.8 265.23 260.43 268.66 260.43 268.92 258.67 265.23 258.8 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "258.92 265.23 260.43 268.39 260.43 268.66 258.8 265.23 258.92 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "259.05 265.23 260.43 268.13 260.43 268.39 258.92 265.23 259.05 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "259.17 265.23 260.43 267.87 260.43 268.13 259.05 265.23 259.17 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "259.3 265.23 260.43 267.6 260.43 267.87 259.17 265.23 259.3 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "259.42 265.23 260.43 267.34 260.43 267.6 259.3 265.23 259.42 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "259.55 265.23 260.43 267.08 260.43 267.34 259.42 265.23 259.55 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "259.67 265.23 260.43 266.81 260.43 267.08 259.55 265.23 259.67 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "259.8 265.23 260.43 266.55 260.43 266.81 259.67 265.23 259.8 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "259.93 265.23 260.43 266.28 260.43 266.55 259.8 265.23 259.93 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "260.05 265.23 260.43 266.02 260.43 266.28 259.93 265.23 260.05 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "260.18 265.23 260.43 265.76 260.43 266.02 260.05 265.23 260.18 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "260.3 265.23 260.43 265.49 260.43 265.76 260.18 265.23 260.3 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "260.43 265.49 260.3 265.23 260.43 265.23 260.43 265.49"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "230.19 153.22 229.9 152.61 230.19 152.61 230.19 153.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "230.19 155.8 228.67 152.61 229.9 152.61 230.19 153.22 230.19 155.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "230.19 158.37 227.45 152.61 228.67 152.61 230.19 155.8 230.19 158.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "230.19 160.94 226.22 152.61 227.45 152.61 230.19 158.37 230.19 160.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "230.19 163.52 225 152.61 226.22 152.61 230.19 160.94 230.19 163.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "230.19 166.09 223.78 152.61 225 152.61 230.19 163.52 230.19 166.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "230.19 168.66 222.55 152.61 223.78 152.61 230.19 166.09 230.19 168.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "230.19 171.24 221.33 152.61 222.55 152.61 230.19 168.66 230.19 171.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "230.19 172.18 229.56 172.48 220.1 152.61 221.33 152.61 230.19 171.24 230.19 172.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "229.56 172.48 228.56 172.96 218.88 152.61 220.1 152.61 229.56 172.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "228.56 172.96 227.56 173.43 217.65 152.61 218.88 152.61 228.56 172.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "227.56 173.43 226.56 173.91 216.43 152.61 217.65 152.61 227.56 173.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "226.56 173.91 225.56 174.38 215.21 152.61 216.43 152.61 226.56 173.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "225.56 174.38 224.57 174.86 213.98 152.61 215.21 152.61 225.56 174.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "224.57 174.86 223.57 175.33 212.76 152.61 213.98 152.61 224.57 174.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "223.57 175.33 222.57 175.81 211.53 152.61 212.76 152.61 223.57 175.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "222.57 175.81 221.57 176.28 210.31 152.61 211.53 152.61 222.57 175.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "221.57 176.28 220.57 176.76 209.08 152.61 210.31 152.61 221.57 176.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "220.57 176.76 219.57 177.23 207.86 152.61 209.08 152.61 220.57 176.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "219.57 177.23 218.58 177.71 206.64 152.61 207.86 152.61 219.57 177.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "218.58 177.71 217.58 178.18 205.41 152.61 206.64 152.61 218.58 177.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "217.58 178.18 216.58 178.66 204.19 152.61 205.41 152.61 217.58 178.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "216.58 178.66 215.58 179.13 202.96 152.61 204.19 152.61 216.58 178.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "215.58 179.13 214.58 179.6 201.74 152.61 202.96 152.61 215.58 179.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "214.58 179.6 213.58 180.08 200.52 152.61 201.74 152.61 214.58 179.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "213.58 180.08 212.59 180.55 199.29 152.61 200.52 152.61 213.58 180.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "212.59 180.55 211.59 181.03 198.07 152.61 199.29 152.61 212.59 180.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "211.59 181.03 210.59 181.5 196.84 152.61 198.07 152.61 211.59 181.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "210.59 181.5 209.59 181.98 195.62 152.61 196.84 152.61 210.59 181.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "209.59 181.98 208.59 182.45 194.39 152.61 195.62 152.61 209.59 181.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "208.59 182.45 207.59 182.93 193.17 152.61 194.39 152.61 208.59 182.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "207.59 182.93 206.6 183.4 191.95 152.61 193.17 152.61 207.59 182.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "206.6 183.4 205.6 183.88 190.72 152.61 191.95 152.61 206.6 183.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "205.6 183.88 204.6 184.35 189.5 152.61 190.72 152.61 205.6 183.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "204.6 184.35 203.6 184.83 188.27 152.61 189.5 152.61 204.6 184.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "203.6 184.83 202.6 185.3 187.05 152.61 188.27 152.61 203.6 184.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "202.6 185.3 201.6 185.78 185.82 152.61 187.05 152.61 202.6 185.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "201.6 185.78 200.61 186.25 184.77 152.96 184.77 152.61 185.82 152.61 201.6 185.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "200.61 186.25 199.61 186.73 184.77 155.54 184.77 152.96 200.61 186.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "199.61 186.73 198.61 187.2 184.77 158.11 184.77 155.54 199.61 186.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "198.61 187.2 197.61 187.68 184.77 160.68 184.77 158.11 198.61 187.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "197.61 187.68 196.61 188.15 184.77 163.26 184.77 160.68 197.61 187.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "196.61 188.15 195.61 188.63 184.77 165.83 184.77 163.26 196.61 188.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "195.61 188.63 194.62 189.1 184.77 168.41 184.77 165.83 195.61 188.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "194.62 189.1 193.62 189.58 184.77 170.98 184.77 168.41 194.62 189.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "193.62 189.58 192.62 190.05 184.77 173.55 184.77 170.98 193.62 189.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "192.62 190.05 191.62 190.53 184.77 176.13 184.77 173.55 192.62 190.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "191.62 190.53 190.62 191 184.77 178.7 184.77 176.13 191.62 190.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "190.62 191 189.62 191.48 184.77 181.27 184.77 178.7 190.62 191"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "189.62 191.48 188.63 191.95 184.77 183.85 184.77 181.27 189.62 191.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "188.63 191.95 188.14 192.18 187.51 192.18 184.77 186.42 184.77 183.85 188.63 191.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "186.29 192.18 184.77 188.99 184.77 186.42 187.51 192.18 186.29 192.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "185.06 192.18 184.77 191.57 184.77 188.99 186.29 192.18 185.06 192.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "184.77 191.57 185.06 192.18 184.77 192.18 184.77 191.57"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "181.94 190.86 181.94 190.86 184.63 196.51 181.94 196.51 181.94 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "182.06 190.86 184.75 196.51 184.63 196.51 181.94 190.86 182.06 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "182.19 190.86 184.88 196.51 184.75 196.51 182.06 190.86 182.19 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "182.32 190.86 185 196.51 184.88 196.51 182.19 190.86 182.32 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "182.44 190.86 185.13 196.51 185 196.51 182.32 190.86 182.44 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "182.57 190.86 185.26 196.51 185.13 196.51 182.44 190.86 182.57 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "182.69 190.86 185.38 196.51 185.26 196.51 182.57 190.86 182.69 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "182.82 190.86 185.51 196.51 185.38 196.51 182.69 190.86 182.82 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "182.94 190.86 185.63 196.51 185.51 196.51 182.82 190.86 182.94 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "183.07 190.86 185.76 196.51 185.63 196.51 182.94 190.86 183.07 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "183.19 190.86 185.88 196.51 185.76 196.51 183.07 190.86 183.19 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "183.32 190.86 186.01 196.51 185.88 196.51 183.19 190.86 183.32 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "183.45 190.86 186.13 196.51 186.01 196.51 183.32 190.86 183.45 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "183.57 190.86 186.26 196.51 186.13 196.51 183.45 190.86 183.57 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "183.7 190.86 186.38 196.51 186.26 196.51 183.57 190.86 183.7 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "183.82 190.86 186.51 196.51 186.38 196.51 183.7 190.86 183.82 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "183.95 190.86 186.64 196.51 186.51 196.51 183.82 190.86 183.95 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "184.07 190.86 186.76 196.51 186.64 196.51 183.95 190.86 184.07 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "184.2 190.86 186.89 196.51 186.76 196.51 184.07 190.86 184.2 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "184.32 190.86 187.01 196.51 186.89 196.51 184.2 190.86 184.32 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "184.45 190.86 187.14 196.51 187.01 196.51 184.32 190.86 184.45 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "184.57 190.86 187.26 196.51 187.14 196.51 184.45 190.86 184.57 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "184.7 190.86 187.38 196.49 187.33 196.51 187.26 196.51 184.57 190.86 184.7 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "184.83 190.86 187.48 196.44 187.38 196.49 184.7 190.86 184.83 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "184.95 190.86 187.58 196.39 187.48 196.44 184.83 190.86 184.95 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "185.08 190.86 187.69 196.34 187.58 196.39 184.95 190.86 185.08 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "185.2 190.86 187.79 196.29 187.69 196.34 185.08 190.86 185.2 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "185.33 190.86 187.89 196.24 187.79 196.29 185.2 190.86 185.33 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "185.45 190.86 187.99 196.19 187.89 196.24 185.33 190.86 185.45 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "185.58 190.86 188.1 196.15 187.99 196.19 185.45 190.86 185.58 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "185.7 190.86 188.2 196.1 188.1 196.15 185.58 190.86 185.7 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "185.83 190.86 188.3 196.05 188.2 196.1 185.7 190.86 185.83 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "185.96 190.86 188.4 196 188.3 196.05 185.83 190.86 185.96 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "186.08 190.86 188.47 195.87 188.47 195.97 188.4 196 185.96 190.86 186.08 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "186.21 190.86 188.47 195.6 188.47 195.87 186.08 190.86 186.21 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "186.33 190.86 188.47 195.34 188.47 195.6 186.21 190.86 186.33 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "186.46 190.86 188.47 195.08 188.47 195.34 186.33 190.86 186.46 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "186.58 190.86 188.47 194.81 188.47 195.08 186.46 190.86 186.58 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "186.71 190.86 188.47 194.55 188.47 194.81 186.58 190.86 186.71 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "186.83 190.86 188.47 194.29 188.47 194.55 186.71 190.86 186.83 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "186.96 190.86 188.47 194.02 188.47 194.29 186.83 190.86 186.96 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "187.08 190.86 188.47 193.76 188.47 194.02 186.96 190.86 187.08 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "187.21 190.86 188.47 193.49 188.47 193.76 187.08 190.86 187.21 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "187.34 190.86 188.47 193.23 188.47 193.49 187.21 190.86 187.34 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "187.46 190.86 188.47 192.97 188.47 193.23 187.34 190.86 187.46 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "187.59 190.86 188.47 192.7 188.47 192.97 187.46 190.86 187.59 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "187.71 190.86 188.47 192.44 188.47 192.7 187.59 190.86 187.71 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "187.84 190.86 188.47 192.18 188.47 192.44 187.71 190.86 187.84 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "187.96 190.86 188.47 191.91 188.47 192.18 187.84 190.86 187.96 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "188.09 190.86 188.47 191.65 188.47 191.91 187.96 190.86 188.09 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "188.21 190.86 188.47 191.38 188.47 191.65 188.09 190.86 188.21 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "188.34 190.86 188.47 191.12 188.47 191.38 188.21 190.86 188.34 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "188.47 191.12 188.34 190.86 188.47 190.86 188.47 191.12"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "287.33 152.61 287.03 153.22 287.03 152.61 287.33 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "288.55 152.61 287.03 155.8 287.03 153.22 287.33 152.61 288.55 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "289.77 152.61 287.03 158.37 287.03 155.8 288.55 152.61 289.77 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "291 152.61 287.03 160.94 287.03 158.37 289.77 152.61 291 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "292.22 152.61 287.03 163.52 287.03 160.94 291 152.61 292.22 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "293.45 152.61 287.03 166.09 287.03 163.52 292.22 152.61 293.45 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "294.67 152.61 287.03 168.66 287.03 166.09 293.45 152.61 294.67 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "295.89 152.61 287.03 171.24 287.03 168.66 294.67 152.61 295.89 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.12 152.61 287.67 172.48 287.03 172.18 287.03 171.24 295.89 152.61 297.12 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "298.34 152.61 288.66 172.96 287.67 172.48 297.12 152.61 298.34 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "299.57 152.61 289.66 173.43 288.66 172.96 298.34 152.61 299.57 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "300.79 152.61 290.66 173.91 289.66 173.43 299.57 152.61 300.79 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "302.02 152.61 291.66 174.38 290.66 173.91 300.79 152.61 302.02 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "303.24 152.61 292.66 174.86 291.66 174.38 302.02 152.61 303.24 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "304.46 152.61 293.66 175.33 292.66 174.86 303.24 152.61 304.46 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "305.69 152.61 294.65 175.81 293.66 175.33 304.46 152.61 305.69 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "306.91 152.61 295.65 176.28 294.65 175.81 305.69 152.61 306.91 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "308.14 152.61 296.65 176.76 295.65 176.28 306.91 152.61 308.14 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "309.36 152.61 297.65 177.23 296.65 176.76 308.14 152.61 309.36 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "310.59 152.61 298.65 177.71 297.65 177.23 309.36 152.61 310.59 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "311.81 152.61 299.65 178.18 298.65 177.71 310.59 152.61 311.81 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "313.03 152.61 300.64 178.66 299.65 178.18 311.81 152.61 313.03 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "314.26 152.61 301.64 179.13 300.64 178.66 313.03 152.61 314.26 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "315.48 152.61 302.64 179.6 301.64 179.13 314.26 152.61 315.48 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "316.71 152.61 303.64 180.08 302.64 179.6 315.48 152.61 316.71 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "317.93 152.61 304.64 180.55 303.64 180.08 316.71 152.61 317.93 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "319.16 152.61 305.63 181.03 304.64 180.55 317.93 152.61 319.16 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "320.38 152.61 306.63 181.5 305.63 181.03 319.16 152.61 320.38 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "321.6 152.61 307.63 181.98 306.63 181.5 320.38 152.61 321.6 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "322.83 152.61 308.63 182.45 307.63 181.98 321.6 152.61 322.83 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "324.05 152.61 309.63 182.93 308.63 182.45 322.83 152.61 324.05 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "325.28 152.61 310.63 183.4 309.63 182.93 324.05 152.61 325.28 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "326.5 152.61 311.62 183.88 310.63 183.4 325.28 152.61 326.5 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "327.73 152.61 312.62 184.35 311.62 183.88 326.5 152.61 327.73 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "328.95 152.61 313.62 184.83 312.62 184.35 327.73 152.61 328.95 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "330.17 152.61 314.62 185.3 313.62 184.83 328.95 152.61 330.17 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "331.4 152.61 315.62 185.78 314.62 185.3 330.17 152.61 331.4 152.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "332.45 152.96 316.62 186.25 315.62 185.78 331.4 152.61 332.45 152.61 332.45 152.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "332.45 155.54 317.61 186.73 316.62 186.25 332.45 152.96 332.45 155.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "332.45 158.11 318.61 187.2 317.61 186.73 332.45 155.54 332.45 158.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "332.45 160.68 319.61 187.68 318.61 187.2 332.45 158.11 332.45 160.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "332.45 163.26 320.61 188.15 319.61 187.68 332.45 160.68 332.45 163.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "332.45 165.83 321.61 188.63 320.61 188.15 332.45 163.26 332.45 165.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "332.45 168.41 322.61 189.1 321.61 188.63 332.45 165.83 332.45 168.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "332.45 170.98 323.6 189.58 322.61 189.1 332.45 168.41 332.45 170.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "332.45 173.55 324.6 190.05 323.6 189.58 332.45 170.98 332.45 173.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "332.45 176.13 325.6 190.53 324.6 190.05 332.45 173.55 332.45 176.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "332.45 178.7 326.6 191 325.6 190.53 332.45 176.13 332.45 178.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "332.45 181.27 327.6 191.48 326.6 191 332.45 178.7 332.45 181.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "332.45 183.85 328.6 191.95 327.6 191.48 332.45 181.27 332.45 183.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "332.45 186.42 329.71 192.18 329.08 192.18 328.6 191.95 332.45 183.85 332.45 186.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "332.45 188.99 330.93 192.18 329.71 192.18 332.45 186.42 332.45 188.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "332.45 191.57 332.16 192.18 330.93 192.18 332.45 188.99 332.45 191.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "332.16 192.18 332.45 191.57 332.45 192.18 332.16 192.18"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "332.32 196.51 335.01 190.86 335.01 196.51 332.32 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "332.2 196.51 334.88 190.86 335.01 190.86 332.32 196.51 332.2 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "332.07 196.51 334.76 190.86 334.88 190.86 332.2 196.51 332.07 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "331.94 196.51 334.63 190.86 334.76 190.86 332.07 196.51 331.94 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "331.82 196.51 334.51 190.86 334.63 190.86 331.94 196.51 331.82 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "331.69 196.51 334.38 190.86 334.51 190.86 331.82 196.51 331.69 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "331.57 196.51 334.26 190.86 334.38 190.86 331.69 196.51 331.57 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "331.44 196.51 334.13 190.86 334.26 190.86 331.57 196.51 331.44 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "331.32 196.51 334.01 190.86 334.13 190.86 331.44 196.51 331.32 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "331.19 196.51 333.88 190.86 334.01 190.86 331.32 196.51 331.19 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "331.07 196.51 333.75 190.86 333.88 190.86 331.19 196.51 331.07 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "330.94 196.51 333.63 190.86 333.75 190.86 331.07 196.51 330.94 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "330.82 196.51 333.5 190.86 333.63 190.86 330.94 196.51 330.82 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "330.69 196.51 333.38 190.86 333.5 190.86 330.82 196.51 330.69 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "330.56 196.51 333.25 190.86 333.38 190.86 330.69 196.51 330.56 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "330.44 196.51 333.13 190.86 333.25 190.86 330.56 196.51 330.44 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "330.31 196.51 333 190.86 333.13 190.86 330.44 196.51 330.31 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "330.19 196.51 332.88 190.86 333 190.86 330.31 196.51 330.19 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "330.06 196.51 332.75 190.86 332.88 190.86 330.19 196.51 330.06 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "329.94 196.51 332.63 190.86 332.75 190.86 330.06 196.51 329.94 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "329.81 196.51 332.5 190.86 332.63 190.86 329.94 196.51 329.81 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "329.69 196.51 332.37 190.86 332.5 190.86 329.81 196.51 329.69 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "329.61 196.51 329.57 196.49 332.25 190.86 332.37 190.86 329.69 196.51 329.61 196.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "329.57 196.49 329.47 196.44 332.12 190.86 332.25 190.86 329.57 196.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "329.47 196.44 329.37 196.39 332 190.86 332.12 190.86 329.47 196.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "329.37 196.39 329.26 196.34 331.87 190.86 332 190.86 329.37 196.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "329.26 196.34 329.16 196.29 331.75 190.86 331.87 190.86 329.26 196.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "329.16 196.29 329.06 196.24 331.62 190.86 331.75 190.86 329.16 196.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "329.06 196.24 328.96 196.19 331.5 190.86 331.62 190.86 329.06 196.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "328.96 196.19 328.85 196.15 331.37 190.86 331.5 190.86 328.96 196.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "328.85 196.15 328.75 196.1 331.24 190.86 331.37 190.86 328.85 196.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "328.75 196.1 328.65 196.05 331.12 190.86 331.24 190.86 328.75 196.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "328.65 196.05 328.55 196 330.99 190.86 331.12 190.86 328.65 196.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "328.55 196 328.48 195.97 328.48 195.87 330.87 190.86 330.99 190.86 328.55 196"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "328.48 195.6 330.74 190.86 330.87 190.86 328.48 195.87 328.48 195.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "328.48 195.34 330.62 190.86 330.74 190.86 328.48 195.6 328.48 195.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "328.48 195.08 330.49 190.86 330.62 190.86 328.48 195.34 328.48 195.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "328.48 194.81 330.37 190.86 330.49 190.86 328.48 195.08 328.48 194.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "328.48 194.55 330.24 190.86 330.37 190.86 328.48 194.81 328.48 194.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "328.48 194.29 330.12 190.86 330.24 190.86 328.48 194.55 328.48 194.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "328.48 194.02 329.99 190.86 330.12 190.86 328.48 194.29 328.48 194.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "328.48 193.76 329.86 190.86 329.99 190.86 328.48 194.02 328.48 193.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "328.48 193.49 329.74 190.86 329.86 190.86 328.48 193.76 328.48 193.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "328.48 193.23 329.61 190.86 329.74 190.86 328.48 193.49 328.48 193.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "328.48 192.97 329.49 190.86 329.61 190.86 328.48 193.23 328.48 192.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "328.48 192.7 329.36 190.86 329.49 190.86 328.48 192.97 328.48 192.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "328.48 192.44 329.24 190.86 329.36 190.86 328.48 192.7 328.48 192.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "328.48 192.18 329.11 190.86 329.24 190.86 328.48 192.44 328.48 192.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "328.48 191.91 328.99 190.86 329.11 190.86 328.48 192.18 328.48 191.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "328.48 191.65 328.86 190.86 328.99 190.86 328.48 191.91 328.48 191.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "328.48 191.38 328.73 190.86 328.86 190.86 328.48 191.65 328.48 191.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "328.48 191.12 328.61 190.86 328.73 190.86 328.48 191.38 328.48 191.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "328.48 190.86 328.48 190.86 328.61 190.86 328.48 191.12 328.48 190.86"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 184.24,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 187.08,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 189.92,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 192.76,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 195.6,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 198.44,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 201.28,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 204.12,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 206.96,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 209.8,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 212.64,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 215.48,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 218.32,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 221.16,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 224,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 226.84,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 229.68,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 232.52,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 235.36,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.2,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 241.04,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 243.88,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 246.72,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 249.56,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 252.4,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 255.24,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 258.08,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 260.92,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 263.76,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 266.6,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 269.44,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 272.28,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 275.12,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 277.96,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 280.8,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 283.64,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 286.48,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 289.32,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 292.16,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 295,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 297.84,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 300.68,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 303.52,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 306.36,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 309.2,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 312.04,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 314.88,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 317.72,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 320.56,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 323.4,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 326.24,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 329.08,
    y: 233.62,
    width: 2.84,
    height: 15.67
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 157.15,
    y: 60.17,
    width: 61.62,
    height: 6.91,
    rx: 3.36,
    ry: 3.36
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 157.15,
    y: 75.58,
    width: 61.62,
    height: 6.91,
    rx: 3.36,
    ry: 3.36
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M418.74,95.95c-.44,0-.85-.23-1.08-.62l-2.59-4.42c-2.42-.12-4.8-.59-7.1-1.4l-4.07,3.11c-.42.32-1.01.34-1.45.05l-5.55-3.69c-.45-.3-.65-.84-.52-1.36l1.29-4.96c-1.63-1.8-2.99-3.82-4.03-6l-5.08-.68c-.53-.07-.96-.47-1.06-.99l-1.32-6.54c-.11-.52.13-1.06.6-1.33l4.42-2.59c.12-2.42.59-4.8,1.4-7.1l-3.11-4.07c-.32-.43-.34-1.01-.05-1.46l3.69-5.55c.3-.45.84-.65,1.36-.52l4.96,1.29c1.8-1.63,3.82-2.99,6-4.03l.68-5.08c.07-.53.47-.96,1-1.06l6.54-1.32c.52-.11,1.06.13,1.33.59l2.59,4.42c2.42.12,4.8.59,7.1,1.4l4.07-3.11c.43-.32,1.01-.34,1.45-.05l5.55,3.69c.45.3.65.84.52,1.36l-1.29,4.96c1.63,1.8,2.99,3.82,4.03,6l5.08.68c.53.07.96.47,1.06.99l1.32,6.54c.11.52-.13,1.06-.6,1.33l-4.42,2.59c-.12,2.42-.59,4.8-1.4,7.1l3.11,4.07c.32.43.34,1.01.05,1.45l-3.69,5.55c-.3.45-.84.65-1.36.52l-4.96-1.29c-1.8,1.63-3.82,2.99-6,4.03l-.68,5.08c-.07.53-.47.96-1,1.06l-6.54,1.32c-.08.02-.17.02-.25.02ZM407.7,87.72l.41.15c2.4.89,4.9,1.39,7.45,1.47h.44s2.91,4.98,2.91,4.98l6.06-1.22.77-5.7.4-.18c2.32-1.06,4.44-2.48,6.3-4.23l.32-.3,5.57,1.45,3.43-5.15-3.49-4.58.15-.41c.89-2.4,1.39-4.9,1.47-7.45v-.44s4.98-2.91,4.98-2.91l-1.22-6.06-5.7-.77-.18-.4c-1.06-2.32-2.48-4.44-4.23-6.3l-.3-.32,1.45-5.57-5.15-3.43-4.58,3.49-.41-.15c-2.4-.89-4.9-1.39-7.45-1.47h-.44s-2.91-4.98-2.91-4.98l-6.06,1.22-.77,5.7-.4.18c-2.32,1.06-4.44,2.48-6.3,4.23l-.32.3-5.57-1.45-3.43,5.15,3.49,4.58-.15.41c-.89,2.4-1.39,4.9-1.47,7.45v.44s-4.98,2.91-4.98,2.91l1.22,6.06,5.7.77.18.4c1.06,2.32,2.48,4.44,4.23,6.3l.3.32-1.45,5.57,5.15,3.43,4.58-3.49ZM388.76,74.39h0ZM416.41,82.74c-3.29,0-6.52-.97-9.32-2.83-3.76-2.5-6.32-6.31-7.21-10.73-.24-1.18-.35-2.39-.33-3.58,0-.44.38-.79.81-.79.44,0,.79.37.79.81-.02,1.08.09,2.17.3,3.24.81,4.01,3.12,7.46,6.53,9.72,3.4,2.26,7.48,3.07,11.49,2.26,4.01-.81,7.46-3.12,9.72-6.53,2.26-3.4,3.07-7.48,2.26-11.49-1.66-8.27-9.74-13.65-18.01-11.98-2.72.55-5.23,1.82-7.27,3.67-.33.3-.83.27-1.13-.05-.3-.33-.27-.83.05-1.13,2.25-2.05,5.03-3.45,8.03-4.06,9.13-1.84,18.05,4.1,19.89,13.23,1.84,9.13-4.1,18.05-13.23,19.89-1.12.23-2.25.34-3.37.34Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M416.33,72.5c-2.51,0-4.92-1.41-6.07-3.82h0c-1.6-3.34-.18-7.36,3.17-8.96,3.34-1.6,7.36-.18,8.96,3.17.77,1.62.87,3.44.27,5.14-.6,1.69-1.82,3.05-3.44,3.82-.93.45-1.92.66-2.89.66ZM411.7,67.99c1.22,2.55,4.28,3.63,6.83,2.41,2.55-1.22,3.63-4.28,2.42-6.83-1.22-2.55-4.29-3.63-6.83-2.42-2.55,1.22-3.63,4.28-2.41,6.84h0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M459.75,103.99c-.1,0-.2-.01-.29-.04l-3.07-.92c-.42-.13-.71-.5-.72-.93l-.09-2.24c-.9-.56-1.72-1.23-2.44-1.99l-2.21.36c-.43.07-.85-.14-1.06-.52l-1.52-2.83c-.2-.38-.15-.85.15-1.17l1.52-1.65c-.24-1.03-.34-2.08-.31-3.14l-1.82-1.31c-.35-.25-.5-.7-.38-1.12l.92-3.07c.12-.41.5-.71.93-.72l2.24-.09c.56-.9,1.23-1.72,1.99-2.44l-.36-2.21c-.07-.43.14-.85.52-1.06l2.83-1.52c.38-.2.85-.15,1.17.15l1.65,1.52c1.03-.24,2.08-.34,3.14-.31l1.31-1.82c.25-.35.7-.5,1.12-.38l3.07.92c.42.13.71.5.72.93l.09,2.24c.9.56,1.72,1.23,2.44,1.99l2.21-.36c.43-.07.85.14,1.06.52l1.52,2.83c.21.38.15.85-.15,1.17l-1.52,1.65c.24,1.03.34,2.08.32,3.14l1.82,1.31c.35.25.5.7.38,1.12l-.92,3.07c-.12.41-.5.71-.93.72l-2.24.09c-.56.9-1.23,1.72-1.99,2.44l.36,2.21c.07.43-.14.85-.52,1.06l-2.83,1.52c-.38.2-.85.15-1.17-.15l-1.65-1.52c-1.03.24-2.08.34-3.14.31l-1.31,1.82c-.19.27-.5.42-.82.42ZM459.28,102.64s0,0,0,0h0ZM457.24,101.62l2.28.69,1.58-2.19.44.03c1.18.07,2.36-.05,3.5-.35l.42-.11,1.98,1.83,2.1-1.13-.43-2.67.33-.29c.88-.78,1.63-1.7,2.22-2.72l.22-.38,2.7-.11.69-2.28-2.19-1.58.03-.44c.07-1.18-.05-2.36-.35-3.5l-.11-.42,1.83-1.98-1.13-2.1-2.67.43-.29-.33c-.78-.88-1.7-1.63-2.72-2.22l-.38-.22-.11-2.7-2.28-.69-1.58,2.19-.44-.03c-1.18-.07-2.36.04-3.5.35l-.42.11-1.98-1.83-2.1,1.13.43,2.67-.33.29c-.88.78-1.63,1.7-2.22,2.72l-.22.38-2.7.11-.69,2.28,2.19,1.58-.03.44c-.07,1.18.04,2.36.35,3.5l.11.42-1.83,1.98,1.13,2.1,2.67-.43.29.33c.78.88,1.7,1.63,2.72,2.22l.38.22.11,2.7ZM450.79,97.43h0,0ZM474.76,83.69s0,0,0,0h0ZM462.29,97.79c-.83,0-1.66-.12-2.47-.37-2.18-.66-3.98-2.12-5.06-4.13-.29-.54-.52-1.1-.69-1.68-.12-.42.12-.86.54-.99.42-.12.86.12.99.54.14.47.32.93.56,1.37.88,1.63,2.34,2.83,4.12,3.36,1.78.53,3.65.34,5.29-.53,3.37-1.81,4.64-6.03,2.83-9.4-1.81-3.37-6.03-4.64-9.4-2.83-1.11.6-2.03,1.48-2.67,2.55-.23.38-.71.5-1.09.28-.38-.23-.5-.71-.28-1.09.79-1.32,1.93-2.41,3.29-3.14,4.15-2.23,9.33-.67,11.56,3.48,2.23,4.15.67,9.33-3.48,11.56-1.26.68-2.64,1.02-4.03,1.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M26.94,343.83h100.94c3.22,0,5.83-2.61,5.83-5.83v-151.19c0-3.21-2.6-5.82-5.81-5.83l-101.75-.27c-3.24,0-5.86,2.62-5.84,5.86l.81,151.46c.02,3.21,2.62,5.8,5.83,5.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M31.88,188.17l90.26.56c3.26.02,5.89,2.68,5.88,5.94l-.63,135.7c-.01,3.21-2.59,5.83-5.81,5.89l-87.7,1.6c-3.28.06-5.98-2.55-6.02-5.83l-1.93-137.85c-.05-3.31,2.64-6.02,5.95-6Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 35.55,
    y: 194.01,
    width: 73.08,
    height: 4.16,
    rx: 1.77,
    ry: 1.77
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M43.31,203.6h0c.05.93.81,1.66,1.73,1.67l60.82,1.11c.99.02,1.8-.78,1.8-1.77v-.14c0-.97-.78-1.75-1.74-1.77l-60.82-.96c-1.03-.02-1.85.84-1.79,1.86Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M37.1,333.44c-2.86,0-5.21-2.31-5.26-5.17l-1.97-110.98c-.05-2.9,2.26-5.3,5.16-5.36l82.12-1.6c1.4-.03,2.74.49,3.75,1.47,1.01.98,1.59,2.29,1.61,3.69l2.12,111.59c.03,1.41-.5,2.75-1.48,3.76-.98,1.01-2.3,1.58-3.72,1.6l-82.26.99s-.04,0-.06,0ZM117.25,212.46s-.04,0-.06,0l-82.12,1.6c-1.73.03-3.11,1.47-3.08,3.19h0l1.97,110.98c.03,1.71,1.44,3.08,3.14,3.08.01,0,.03,0,.04,0l82.26-.99c.84,0,1.63-.35,2.22-.95.59-.6.9-1.4.89-2.24l-2.12-111.59c-.02-.84-.36-1.62-.96-2.2-.59-.57-1.36-.88-2.18-.88Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M121.58,223.62H31.99c-.59,0-1.06-.48-1.06-1.06s.48-1.06,1.06-1.06h89.59c.59,0,1.06.48,1.06,1.06s-.48,1.06-1.06,1.06Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 40.28,
    y: 281.01,
    width: 11.16,
    height: 40.54,
    rx: 1.13,
    ry: 1.13
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M78.8,276.16h-8.89c-.62,0-1.14.6-1.14,1.3v42.75c0,.7.52,1.34,1.14,1.34h8.89c.62,0,1.29-.64,1.29-1.34v-42.75c0-.7-.66-1.3-1.29-1.3Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 54.24,
    y: 268.38,
    width: 11.16,
    height: 53.17,
    rx: 1.13,
    ry: 1.13
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 102.56,
    y: 250.31,
    width: 11.16,
    height: 71.24,
    rx: 1.13,
    ry: 1.13
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 85.96,
    y: 260.15,
    width: 11.16,
    height: 61.39,
    rx: 1.13,
    ry: 1.13
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "45.48 267.33 45.27 266.95 60.12 258.83 73.93 264.9 85.79 253.27 85.82 253.26 99.74 245.04 99.96 245.42 86.06 253.62 74.03 265.42 60.14 259.32 45.48 267.33"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M46.97,267.14c0,.88-.72,1.6-1.6,1.6s-1.6-.72-1.6-1.6.72-1.6,1.6-1.6,1.6.72,1.6,1.6Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 60.13,
    cy: 259.08,
    r: 1.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 73.98,
    cy: 264.86,
    r: 1.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 85.55,
    cy: 253.45,
    r: 1.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M101.45,245.23c0,.88-.72,1.6-1.6,1.6s-1.6-.72-1.6-1.6.72-1.6,1.6-1.6,1.6.72,1.6,1.6Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M81.88,296.61l.7,41.4c.05,3.22,2.68,5.79,5.89,5.79h81.25c3.25,0,5.89-2.64,5.89-5.89v-38.75c0-3.18-2.52-5.79-5.7-5.89l-81.95-2.65c-3.37-.11-6.14,2.62-6.08,5.99Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M88.61,300.65l1.76,38.07c.07,1.46,1.29,2.6,2.75,2.58l73.99-1.3c1.47-.03,2.66-1.23,2.66-2.7v-33.02c0-1.44-1.13-2.63-2.57-2.7l-75.75-3.75c-1.59-.08-2.91,1.23-2.84,2.83Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M94.51,304.22v2.74c0,.97.79,1.75,1.76,1.73l63.82-1.04c.94-.02,1.7-.79,1.7-1.73h0c0-.94-.75-1.7-1.68-1.73l-63.82-1.7c-.97-.03-1.78.76-1.78,1.73Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M95.46,314.58v2.52c0,.98.81,1.76,1.79,1.73l60.78-2.12c.93-.03,1.67-.8,1.67-1.73v-.78c0-.96-.78-1.74-1.74-1.73l-60.78.39c-.95,0-1.72.78-1.72,1.73Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M384.05,92.22l2.67-.08c.29,0,.54.22.55.51,0,.29-.22.54-.51.55h0s-2.64.08-2.64.08h-.02c-.29,0-.54-.22-.55-.51,0-.29.22-.54.51-.55h0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M389.37,92.11h2.66c.29-.01.53.23.53.52,0,.29-.23.53-.53.53h-2.65s0,.01,0,.01c-.29,0-.53-.23-.53-.53,0-.29.23-.53.53-.53h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M394.69,92.11l2.66.04c.29,0,.52.24.52.53,0,.29-.24.52-.53.52h0l-2.65-.04h0c-.29,0-.52-.24-.52-.53,0-.29.24-.52.53-.52h0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M400.01,92.22l2.66.09c.29,0,.52.25.51.54,0,.29-.25.52-.54.51h0s-2.65-.09-2.65-.09h0c-.29,0-.52-.25-.51-.54,0-.29.25-.52.54-.51h0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M405.32,92.43l2.66.14c.29.02.51.26.49.55-.02.29-.26.51-.55.49h0s-2.65-.14-2.65-.14h0c-.29-.02-.51-.26-.49-.55.02-.29.26-.51.55-.49h0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M410.64,92.74l2.65.19c.29.02.5.27.48.56-.02.29-.27.5-.56.48h0s-2.64-.19-2.64-.19h0c-.29-.02-.5-.27-.48-.56.02-.29.27-.5.56-.48h0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M415.94,93.14l2.65.24c.28.03.49.28.47.56-.03.28-.28.49-.56.47h0s-2.64-.24-2.64-.24h0c-.29-.03-.5-.28-.47-.56s.28-.5.56-.47h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M421.24,93.66l2.64.3c.28.03.49.29.45.57-.03.28-.29.49-.57.45h0s-2.63-.3-2.63-.3h0c-.28-.03-.49-.29-.46-.57.03-.28.29-.49.57-.46h0Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M426.52,94.29l2.64.36c.28.04.48.3.44.58-.04.28-.3.48-.58.44h0s-2.63-.36-2.63-.36h0c-.28-.04-.48-.3-.44-.58.04-.28.3-.48.58-.44h0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M431.79,95.04l2.63.43c.28.05.47.31.42.59-.05.28-.31.47-.59.42h0s-2.62-.42-2.62-.42h0c-.28-.05-.47-.31-.42-.59.05-.28.31-.47.59-.42h0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M437.04,95.93l2.62.5c.28.05.46.32.4.59-.05.28-.32.46-.59.4h0s-2.6-.5-2.6-.5h0c-.28-.05-.46-.32-.41-.6.05-.28.32-.46.6-.41h0Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M442.27,96.97l2.6.58c.27.06.44.33.38.6-.06.27-.33.44-.6.38h0s-2.58-.58-2.58-.58h0c-.27-.06-.45-.33-.39-.61.06-.27.33-.45.61-.39h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M447.46,98.18l2.58.67c.27.07.43.35.36.62-.07.27-.35.43-.62.36h0s-2.56-.67-2.56-.67h0c-.27-.07-.43-.35-.36-.62.07-.27.35-.43.62-.36h0Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M452.61,99.57l2.55.78c.27.08.41.36.33.63-.08.27-.36.41-.63.33h-.01s-2.53-.77-2.53-.77h-.01c-.27-.08-.42-.37-.34-.63.08-.27.36-.42.63-.34h0Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M457.69,101.19l2.51.9c.26.09.4.38.3.64-.09.26-.38.4-.64.3h-.01s-2.49-.89-2.49-.89h-.01c-.26-.1-.4-.38-.3-.64.09-.26.38-.4.64-.3h0Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M462.7,103.05l2.46,1.04c.25.11.37.4.27.65-.11.25-.4.37-.65.27h-.01s-2.44-1.03-2.44-1.03h-.01c-.25-.11-.37-.4-.27-.66.11-.25.4-.37.65-.27h0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M467.59,105.2l2.39,1.2c.24.12.34.42.22.67-.12.24-.42.34-.67.22h-.02s-2.36-1.19-2.36-1.19h-.02c-.25-.13-.34-.43-.22-.67.12-.25.42-.34.67-.22h0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M472.32,107.69l2.29,1.39c.23.14.31.44.17.68-.14.23-.44.31-.68.17h-.02s-2.25-1.38-2.25-1.38h-.02c-.23-.15-.31-.46-.17-.69.14-.23.45-.31.68-.17h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M476.85,110.53l2.2,1.5c.22.15.28.46.13.68-.15.22-.46.28-.68.13h0s-2.19-1.49-2.19-1.49h0c-.22-.16-.28-.46-.13-.69.15-.22.46-.28.68-.13h0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M481.22,113.58l2.13,1.6c.22.16.26.47.1.68-.16.22-.47.26-.68.1h-.01s-2.11-1.6-2.11-1.6h-.01c-.22-.17-.26-.48-.1-.69.16-.22.47-.26.69-.1h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M485.45,116.85l2.04,1.73c.21.17.23.48.06.69-.17.21-.48.23-.69.06h-.01s-2.02-1.72-2.02-1.72h-.01c-.21-.18-.23-.49-.06-.7.17-.21.48-.23.69-.06h0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M489.46,120.38l1.91,1.87c.19.19.19.49,0,.69-.19.19-.49.19-.69,0h-.01s-1.89-1.86-1.89-1.86h-.01c-.19-.2-.2-.51,0-.7.19-.19.5-.2.69,0h0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M493.21,124.2l1.74,2.04c.17.2.15.51-.06.68-.2.17-.51.15-.68-.06l-.02-.02-1.7-2-.02-.02c-.17-.2-.15-.51.06-.68.2-.17.51-.15.68.06h0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M496.56,128.39l1.48,2.24c.15.22.09.52-.14.67-.22.15-.52.09-.67-.14l-.02-.03-1.45-2.19-.02-.03c-.15-.22-.09-.52.14-.67.22-.15.52-.09.67.14h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M499.36,132.98l1.12,2.46c.11.24,0,.52-.24.63-.24.11-.52,0-.63-.24l-.02-.04-1.08-2.38-.02-.04c-.11-.24,0-.52.24-.63.24-.11.52,0,.63.24h0Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M501.36,137.99c.25.87.45,1.75.6,2.64.04.26-.13.51-.39.55-.26.04-.51-.13-.55-.39-.15-.85-.34-1.7-.58-2.54-.07-.25.07-.52.33-.59.25-.07.52.07.59.33h0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M502.26,143.33c.05.9.04,1.81-.03,2.71-.02.26-.25.46-.51.44s-.46-.25-.44-.51c.06-.86.07-1.73.02-2.6-.01-.26.19-.49.45-.5.26-.01.49.19.5.45h0Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M501.88,148.73c-.17.89-.4,1.76-.67,2.62-.08.25-.34.39-.59.31-.25-.08-.39-.34-.31-.59.26-.83.47-1.67.64-2.52.05-.26.3-.42.55-.37.26.05.42.3.37.55h0Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M500.26,153.88l-1.19,2.42c-.11.23-.4.33-.63.21-.23-.11-.33-.4-.21-.63l.02-.04,1.15-2.35.02-.04c.11-.23.4-.33.63-.22.23.11.33.4.22.63h0Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M497.68,158.61l-1.56,2.19c-.15.21-.44.26-.65.11-.21-.15-.26-.44-.11-.65l.02-.03,1.52-2.14.02-.03c.15-.21.44-.26.65-.11.21.15.26.44.11.65h0Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M494.42,162.88l-1.81,1.97c-.17.19-.47.2-.66.03-.19-.17-.2-.47-.03-.66l.02-.02,1.78-1.94.02-.02c.17-.19.47-.2.66-.03.19.17.2.47.03.66h0Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M490.7,166.73l-1.99,1.79c-.19.17-.48.16-.65-.03-.17-.19-.16-.48.03-.65h.01s1.96-1.78,1.96-1.78h.01c.19-.18.48-.17.66.02.17.19.16.48-.03.66h0Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M486.65,170.22l-2.08,1.65h0c-.2.16-.49.13-.65-.07-.16-.2-.12-.49.08-.65l2.08-1.65h0c.2-.16.49-.13.65.07.16.2.13.49-.08.65h0Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M482.51,173.54l-2.03,1.7h0c-.19.17-.48.14-.65-.05-.16-.19-.14-.48.06-.65l2.04-1.71c.19-.16.48-.14.65.06.16.19.14.48-.06.65h0s0,0,0,0Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M478.48,176.98l-1.96,1.78h0c-.19.18-.48.16-.65-.02-.17-.19-.16-.48.03-.65l1.97-1.8c.19-.17.48-.16.65.03.17.19.16.48-.03.65h0s0,0,0,0Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M474.63,180.6l-1.83,1.9h-.01c-.17.19-.46.2-.64.03-.18-.17-.19-.46-.01-.64l1.86-1.93c.17-.18.46-.19.64-.01.18.17.19.46.01.64h0s-.01.01-.01.01Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M471.05,184.48l-1.62,2.07-.02.03c-.15.2-.44.23-.63.08-.2-.15-.23-.44-.08-.63l1.65-2.12c.15-.2.44-.23.64-.08.2.15.23.44.08.64h0s-.02.02-.02.02Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M468,188.74c-.44.75-.85,1.52-1.2,2.31-.1.23-.37.33-.59.23-.23-.1-.33-.37-.23-.59.37-.83.79-1.63,1.25-2.4.13-.21.4-.28.62-.16.21.13.29.4.16.62h0Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M465.92,193.48c-.23.83-.38,1.68-.46,2.53-.02.25-.24.43-.49.41-.25-.02-.43-.24-.41-.49.08-.91.25-1.81.49-2.69.07-.24.31-.38.55-.32.24.06.38.31.32.55h0Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M465.46,198.58c.07.86.21,1.71.41,2.56.06.24-.09.48-.33.54-.24.06-.48-.09-.54-.33-.21-.88-.36-1.78-.43-2.68-.02-.25.16-.46.41-.48.25-.02.46.16.48.41h0Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M466.6,203.64l.95,2.45v.03c.1.23-.01.49-.24.57-.23.09-.49-.02-.57-.25l-.98-2.5c-.09-.23.02-.49.25-.58.23-.09.49.02.58.25h0s.01.03.01.03Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M468.64,208.49l1.17,2.37h0c.11.23.02.49-.2.6-.22.11-.48.02-.59-.2l-1.18-2.39c-.11-.22-.02-.48.2-.59.22-.11.48-.02.59.2h0s0,0,0,0Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M471,213.25l1.03,2.49c.09.22-.01.48-.24.57-.22.09-.48-.01-.57-.24v-.03s-1.01-2.42-1.01-2.42l-.02-.04c-.09-.22.01-.48.24-.57.22-.09.48.01.57.24h0Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M472.85,218.3l.66,2.6c.06.23-.08.47-.32.53-.23.06-.47-.08-.53-.32v-.03s-.65-2.55-.65-2.55v-.03c-.07-.23.08-.47.31-.53.23-.06.47.08.53.32h0Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M474.01,223.53l.36,2.65c.03.24-.13.46-.37.49-.24.03-.46-.13-.49-.37v-.02s-.36-2.61-.36-2.61v-.02c-.04-.24.13-.46.37-.49.24-.03.46.14.49.37h0Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M474.58,228.85l.07,2.68c0,.24-.18.44-.42.44-.24,0-.44-.18-.44-.42v-.02s-.07-2.63-.07-2.63v-.02c0-.24.18-.44.42-.45.24,0,.44.18.45.42h0Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M474.59,234.2l-.21,2.67c-.02.24-.23.41-.46.4-.24-.02-.41-.23-.4-.46v-.02s.21-2.62.21-2.62v-.02c.02-.24.23-.42.47-.4.24.02.42.23.4.46h0Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M474.02,239.53l-.5,2.63c-.04.23-.27.39-.5.34-.23-.04-.39-.27-.34-.5v-.02s.49-2.59.49-2.59v-.02c.05-.23.27-.39.51-.34.23.04.39.27.34.5h0Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M472.88,244.76l-.78,2.56c-.07.23-.31.35-.53.28-.23-.07-.35-.31-.28-.53v-.02s.77-2.52.77-2.52v-.02c.08-.23.31-.35.54-.28.23.07.35.31.28.53h0Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M471.18,249.83l-1.06,2.46c-.09.22-.34.31-.56.22-.22-.09-.31-.34-.22-.56v-.02s1.05-2.42,1.05-2.42v-.02c.1-.22.35-.32.57-.22.22.09.32.34.22.56h0Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M468.92,254.69l-1.32,2.33c-.11.2-.37.27-.58.16-.2-.11-.27-.37-.16-.58v-.02s1.31-2.29,1.31-2.29v-.02c.13-.2.38-.28.59-.16.2.12.28.37.16.58h0Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M466.17,259.28l-1.55,2.18c-.13.19-.4.23-.59.1-.19-.13-.23-.4-.1-.59v-.02s1.54-2.15,1.54-2.15v-.02c.15-.19.41-.23.6-.1.19.13.23.4.1.59h0Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M462.95,263.56l-1.76,2.02c-.15.17-.42.19-.59.04s-.19-.42-.04-.59h.01s1.73-2,1.73-2h.01c.15-.19.42-.21.59-.06.17.15.19.42.04.59h0Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M459.35,267.5l-1.93,1.85c-.17.16-.43.15-.59-.01-.16-.17-.15-.43.01-.59h.01s1.9-1.84,1.9-1.84h.01c.17-.17.43-.17.59,0,.16.17.15.43-.01.59h0Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M455.41,271.12l-2.07,1.68c-.18.14-.44.12-.58-.06-.14-.18-.12-.44.06-.58h.01s2.05-1.67,2.05-1.67h.01c.18-.15.44-.13.58.05.14.18.12.44-.06.58h0Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M451.2,274.4l-2.19,1.52c-.19.13-.44.08-.57-.1-.13-.19-.08-.44.1-.57h.01s2.17-1.52,2.17-1.52h.01c.19-.14.44-.09.57.09.13.19.08.44-.1.57h0Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M446.77,277.37l-2.29,1.37c-.19.12-.45.05-.56-.14-.12-.19-.05-.45.14-.56h.01s2.26-1.37,2.26-1.37h.01c.19-.12.45-.06.56.13.12.19.05.45-.14.56h0Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M442.15,280.05l-2.36,1.23c-.2.1-.45.03-.55-.17-.1-.2-.03-.45.17-.55h0s2.34-1.23,2.34-1.23h.01c.2-.11.45-.03.55.17.1.2.03.45-.17.55h0Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M437.39,282.46l-2.42,1.11c-.2.09-.44,0-.54-.2-.09-.2,0-.44.2-.54h0s2.41-1.11,2.41-1.11h0c.2-.1.44,0,.54.2.09.2,0,.44-.2.54h0Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M432.52,284.61l-2.47.99c-.21.08-.44-.02-.52-.22-.08-.21.02-.44.22-.52h0s2.46-.99,2.46-.99h0c.21-.09.44.01.53.22.08.21-.02.44-.22.53h0Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M427.55,286.54l-2.51.88c-.21.07-.44-.04-.51-.24-.07-.21.04-.44.25-.51h0s2.5-.88,2.5-.88h0c.21-.08.44.03.51.24.07.21-.04.44-.25.51h0Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "370.28 63.93 371.69 72.53 365.27 69.78 370.28 63.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "366.27 70.95 371.69 72.53 367.77 68.34 366.27 70.95"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 347.83,
    y: 118.83,
    width: 54.01,
    height: 88.51
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 350.7,
    y: 120.65,
    width: 49.42,
    height: 83.35
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M365.51,154.11c1.82-4.01,4.97-5.26,10.13-5.26,6.12,0,9.37,2.2,10.23,5.45-10.99.19-20.46-.19-20.46-.19h.1Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M373.54,129.35c-2.58.76-2.49,2.2-3.35,3.54-.86,1.34-2.77,2.29-2.96,3.15-.19.86.57,2.77-.38,3.82-.96,1.05-1.24,1.62-.86,2.68.38,1.05,1.24,2.68,1.24,2.96,0,.19,1.15,1.82,2.39,2.01s3.73.57,4.87,1.15c1.24.57,5.07-.67,7.26-.57,2.2,0,3.63-1.53,3.44-2.58-.19-1.05,1.62-3.15,1.62-4.97,0-1.91-2.29-3.44-2.87-4.68-.57-1.24,0-3.54-2.2-4.87-1.43-.86-2.39-.76-3.54-1.15s-3.06-.96-4.68-.48Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M376.7,152c-.57.86-1.05.86-1.62,0-.48-.76-1.53-2.39-1.53-3.15v-8.32c0-.86.67-1.53,1.53-1.53h1.62c.86,0,1.53.67,1.53,1.53v8.32c0,.86-.96,2.39-1.53,3.15Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 375.84,
    cy: 139.1,
    rx: 5.07,
    ry: 6.88
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M378.23,133.65c-3.15,5.35-7.84,4.87-7.84,4.87,0,0,.1-7.07,3.82-7.46,3.73-.38,5.93,1.15,6.69,3.54.76,2.49,0,4.11,0,4.11,0,0-1.24-.96-1.82-2.49-.57-1.53-.86-2.58-.86-2.58Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.86,164.91h-12.71c-.76,0-1.43-.67-1.43-1.43s.67-1.43,1.43-1.43h12.71c.76,0,1.43.67,1.43,1.43s-.67,1.43-1.43,1.43Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.15,169.49h-17.3c-.76,0-1.43-.67-1.43-1.43s.67-1.43,1.43-1.43h17.3c.76,0,1.43.67,1.43,1.43s-.67,1.43-1.43,1.43Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.58,185.74h-42.15c-.48,0-.86-.38-.86-.86s.38-.86.86-.86h42.15c.48,0,.86.38.86.86s-.38.86-.86.86Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.58,189.76h-42.15c-.48,0-.86-.38-.86-.86s.38-.86.86-.86h42.15c.48,0,.86.38.86.86s-.38.86-.86.86Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.58,193.68h-42.15c-.48,0-.86-.38-.86-.86s.38-.86.86-.86h42.15c.48,0,.86.38.86.86s-.38.86-.86.86Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M390.65,155.06h-30.4c-.86,0-1.53-.67-1.53-1.53v-28.01c0-.86.67-1.53,1.53-1.53h30.4c.86,0,1.53.67,1.53,1.53v28.01c0,.86-.67,1.53-1.53,1.53ZM360.35,125.24c-.19,0-.29.1-.29.29v28.01c0,.19.1.29.29.29h30.4c.19,0,.29-.1.29-.29v-28.01c0-.19-.1-.29-.29-.29,0,0-30.4,0-30.4,0Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "364.65 173.32 365.61 175.04 367.52 175.33 366.09 176.76 366.47 178.67 364.65 177.81 362.93 178.67 363.22 176.76 361.88 175.33 363.79 175.04 364.65 173.32"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "371.92 173.32 372.78 175.04 374.69 175.33 373.35 176.76 373.64 178.67 371.92 177.81 370.1 178.67 370.48 176.76 369.05 175.33 370.96 175.04 371.92 173.32"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "379.09 173.32 379.95 175.04 381.95 175.33 380.52 176.76 380.81 178.67 379.09 177.81 377.37 178.67 377.65 176.76 376.22 175.33 378.23 175.04 379.09 173.32"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "386.26 173.32 387.12 175.04 389.12 175.33 387.69 176.76 388.07 178.67 386.26 177.81 384.53 178.67 384.82 176.76 383.39 175.33 385.39 175.04 386.26 173.32"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 468.27,
    y: 118.83,
    width: 54.01,
    height: 88.51
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 471.14,
    y: 120.65,
    width: 49.42,
    height: 83.35
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M488.25,138.62c0,3.92,2.39,10.32,8.03,10.13,5.64-.19,6.88-6.31,7.07-8.03.19-1.72-15.1-2.1-15.1-2.1h0Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M485.95,154.11c1.82-4.01,4.97-5.26,10.13-5.26,6.12,0,9.37,2.2,10.23,5.45-10.99.19-20.46-.19-20.46-.19h.1Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M497.13,152c-.57.86-1.05.86-1.62,0-.48-.76-1.53-2.39-1.53-3.15v-8.32c0-.86.67-1.53,1.53-1.53h1.62c.86,0,1.53.67,1.53,1.53v8.32c0,.86-.96,2.39-1.53,3.15Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 496.27,
    cy: 139.1,
    rx: 5.07,
    ry: 6.88
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.05,133.84c-.57,2.1-1.91,2.1-3.73,2.77s-2.68,1.43-3.25,2.77c-.76,1.72.38,6.69.38,6.69,0,0-4.59-3.44-4.11-8.89.57-5.45,3.73-7.55,6.79-7.55s4.21,1.82,4.21,1.82c0,0,1.62,0,3.15,1.82,2.01,2.39,1.43,8.32,0,10.42s-2.39,2.77-2.29,2.68c0,0,1.34-4.97.67-7.93-.67-2.96-1.62-4.59-1.62-4.59h-.19Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M502.3,164.91h-12.71c-.76,0-1.43-.67-1.43-1.43s.67-1.43,1.43-1.43h12.71c.76,0,1.43.67,1.43,1.43s-.67,1.43-1.43,1.43Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.59,169.49h-17.3c-.76,0-1.43-.67-1.43-1.43s.67-1.43,1.43-1.43h17.3c.76,0,1.43.67,1.43,1.43s-.67,1.43-1.43,1.43Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.02,185.74h-42.15c-.48,0-.86-.38-.86-.86s.38-.86.86-.86h42.15c.48,0,.86.38.86.86s-.38.86-.86.86h0Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.02,189.76h-42.15c-.48,0-.86-.38-.86-.86s.38-.86.86-.86h42.15c.48,0,.86.38.86.86s-.38.86-.86.86h0Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.02,193.68h-42.15c-.48,0-.86-.38-.86-.86s.38-.86.86-.86h42.15c.48,0,.86.38.86.86s-.38.86-.86.86h0Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M511.09,155.06h-30.4c-.86,0-1.53-.67-1.53-1.53v-28.01c0-.86.67-1.53,1.53-1.53h30.4c.86,0,1.53.67,1.53,1.53v28.01c0,.86-.67,1.53-1.53,1.53ZM480.79,125.24c-.19,0-.29.1-.29.29v28.01c0,.19.1.29.29.29h30.4c.19,0,.29-.1.29-.29v-28.01c0-.19-.1-.29-.29-.29h-30.4Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "485.09 173.32 486.05 175.04 487.96 175.33 486.52 176.76 486.91 178.67 485.09 177.81 483.37 178.67 483.75 176.76 482.32 175.33 484.23 175.04 485.09 173.32"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "492.36 173.32 493.22 175.04 495.13 175.33 493.79 176.76 494.08 178.67 492.36 177.81 490.54 178.67 490.92 176.76 489.49 175.33 491.5 175.04 492.36 173.32"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "499.52 173.32 500.38 175.04 502.39 175.33 500.96 176.76 501.24 178.67 499.52 177.81 497.8 178.67 498.09 176.76 496.66 175.33 498.66 175.04 499.52 173.32"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "506.69 173.32 507.65 175.04 509.56 175.33 508.13 176.76 508.51 178.67 506.69 177.81 504.97 178.67 505.26 176.76 503.92 175.33 505.83 175.04 506.69 173.32"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 398.11,
    y: 102.68,
    width: 73.79,
    height: 120.92
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 401.93,
    y: 105.07,
    width: 67.48,
    height: 113.84
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M429.36,129.06c0-.1-1.24-6.88-1.34-9.56-.1-2.68,4.21-3.06,4.21-3.06,0,0,3.54-1.91,6.21-.96,2.58.96,4.4,2.68,5.54,4.68,1.15,2.1-1.05,8.51-1.05,8.51l-13.57.29v.1Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M421.24,150.86c0-.1.29-2.77.29-2.87.57-5.64,7.55-7.17,14.43-7.17,8.12,0,13.67,1.53,14.53,7.36,0,.19.48,2.87.48,3.06-15.1.19-29.73-.29-29.73-.29v-.1Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M437.39,145.12c-.76,1.15-1.43,1.24-2.29,0-.67-.96-3.06-3.25-3.06-4.4l.96-11.28c0-1.15.96-2.1,2.1-2.1h2.29c1.15,0,2.1.96,2.1,2.1l.48,11.28c0,1.15-1.82,3.25-2.49,4.4h-.1Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 436.34,
    cy: 127.44,
    rx: 6.88,
    ry: 9.37
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M432.23,121.13c2.87-2.01,4.11-1.62,6.21,1.62,2.1,3.25,4.68,3.35,4.68,3.35l.29-3.35s-3.15-6.12-7.36-5.35c-4.21.76-6.69,4.59-6.69,4.59,0,0-.19,7.17.38,7.36.57.29.67-2.29,1.05-2.87.38-.48-.38-2.96.1-4.11.57-1.15,1.24-1.34,1.24-1.34l.1.1Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M441.41,124.76c.96,1.05.57,5.35,1.15,5.35s.67-4.11.57-4.49c-.1-.38-1.72-.76-1.72-.76v-.1Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M451.54,165.58h-31.54c-1.15,0-2.01-.86-2.01-2.01s.86-2.01,2.01-2.01h31.54c1.15,0,2.01.86,2.01,2.01s-.86,2.01-2.01,2.01Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.62,171.79h-23.71c-1.15,0-2.01-.86-2.01-2.01s.86-2.01,2.01-2.01h23.71c1.15,0,2.01.86,2.01,2.01s-.86,2.01-2.01,2.01Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.54,194.06h-57.54c-.67,0-1.15-.57-1.15-1.15s.57-1.15,1.15-1.15h57.54c.67,0,1.15.57,1.15,1.15s-.57,1.15-1.15,1.15Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.54,199.51h-57.54c-.67,0-1.15-.57-1.15-1.15s.57-1.15,1.15-1.15h57.54c.67,0,1.15.57,1.15,1.15s-.57,1.15-1.15,1.15Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.54,204.86h-57.54c-.67,0-1.15-.57-1.15-1.15s.57-1.15,1.15-1.15h57.54c.67,0,1.15.57,1.15,1.15s-.57,1.15-1.15,1.15Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M456.51,151.91h-41.48c-1.05,0-1.82-.86-1.82-1.82v-38.23c0-1.05.86-1.82,1.82-1.82h41.48c1.05,0,1.82.86,1.82,1.82v38.23c0,1.05-.86,1.82-1.82,1.82ZM415.03,111.19c-.38,0-.57.29-.57.57v38.23c0,.38.29.57.57.57h41.48c.38,0,.57-.29.57-.57v-38.23c0-.38-.29-.57-.57-.57h-41.48Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "416.08 177.05 417.23 179.44 419.9 179.82 417.99 181.73 418.47 184.41 416.08 183.16 413.69 184.41 414.17 181.73 412.16 179.82 414.84 179.44 416.08 177.05"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "425.92 177.05 427.07 179.44 429.75 179.82 427.84 181.73 428.31 184.41 425.92 183.16 423.53 184.41 423.92 181.73 422 179.82 424.68 179.44 425.92 177.05"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "435.77 177.05 436.92 179.44 439.59 179.82 437.68 181.73 438.16 184.41 435.77 183.16 433.28 184.41 433.76 181.73 431.85 179.82 434.53 179.44 435.77 177.05"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "445.52 177.05 446.76 179.44 449.44 179.82 447.53 181.73 447.91 184.41 445.52 183.16 443.13 184.41 443.61 181.73 441.69 179.82 444.37 179.44 445.52 177.05"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "455.55 177.05 456.7 179.44 459.38 179.82 457.47 181.73 457.94 184.41 455.55 183.16 453.17 184.41 453.64 181.73 451.64 179.82 454.31 179.44 455.55 177.05"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M81.92,291.88l-67.34,37.35c-2.82,1.57-3.72,5.21-1.93,7.9l.29.44c1.58,2.38,4.79,3.03,7.16,1.44l64.3-43.12-2.48-4.02Z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 73.97,
    y: 233.14,
    width: 2.61,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 76.58,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 81.34,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 86.1,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 90.86,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 95.63,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 100.39,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 105.15,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 109.91,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 114.67,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 119.44,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 124.2,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 128.96,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 133.72,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 138.48,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 143.24,
    y: 233.14,
    width: 4.76,
    height: 75.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 148.01,
    y: 233.14,
    width: 2.61,
    height: 75.47
  })))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M106.17,232.47c-21.68,3.44-36.52,23.49-33.14,44.78,3.38,21.29,23.69,35.76,45.38,32.32,21.68-3.44,36.52-23.49,33.14-44.78-3.38-21.29-23.69-35.76-45.38-32.32ZM117.51,303.91c-18.5,2.94-35.83-9.41-38.71-27.57-2.88-18.16,9.78-35.27,28.27-38.2,18.5-2.94,35.83,9.41,38.71,27.57,2.88,18.16-9.78,35.27-28.27,38.2Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M76.73,281.56c-.12,0-.22-.08-.25-.19-.26-.89-.49-1.81-.68-2.73-.03-.14.06-.28.21-.31.14-.03.28.06.31.21.19.9.42,1.8.67,2.69.04.14-.04.29-.18.33-.02,0-.05.01-.07.01ZM75.29,270.73h0c-.15,0-.26-.12-.26-.27.05-2.55.38-5.1.97-7.58,0,0,0,0,0,0,3.48-14.63,15.48-25.62,30.56-28.02,7.03-1.12,14.18-.25,20.67,2.51.13.06.2.21.14.35-.06.14-.21.2-.35.14-6.4-2.72-13.44-3.58-20.38-2.48-14.87,2.36-26.69,13.2-30.13,27.62,0,0,0,0,0,0-.58,2.45-.9,4.96-.95,7.47,0,.14-.12.26-.27.26Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M17.44,338.41s-.03,0-.05,0c-2.94-.52-3.86-2.07-4.1-3.27-.36-1.76.49-3.58,2.12-4.54l8.05-4.71c.13-.07.29-.03.36.1.07.13.03.29-.1.36l-8.05,4.71c-1.43.84-2.18,2.43-1.87,3.97.31,1.52,1.54,2.48,3.67,2.86.14.03.24.16.22.31-.02.13-.13.22-.26.22Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M26.08,324.93c-.09,0-.18-.05-.23-.13-.07-.13-.03-.29.1-.36l1.04-.61c.13-.07.29-.03.36.1.07.13.03.29-.1.36l-1.04.61s-.09.04-.13.04Z"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M334.4,345.76h114.23v-41.17c0-3.87-3.13-7-7-7h-100.23c-3.87,0-7,3.13-7,7v41.17Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.63,346.1h-114.23c-.19,0-.34-.15-.34-.34v-41.17c0-4.05,3.29-7.34,7.34-7.34h100.23c4.05,0,7.34,3.29,7.34,7.34v41.17c0,.19-.15.34-.34.34ZM334.74,345.42h113.54v-40.83c0-3.67-2.99-6.66-6.66-6.66h-100.23c-3.67,0-6.66,2.99-6.66,6.66v40.83Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M358.52,300.61c2,1.71,6.88,6.72,5.56,13.96-1.65,9.04-5.28,10.72-8.03,17.08-2.75,6.35-2.02,10.03-2.02,10.03l-20.35.57s1.53-28.15.51-41.63h24.33Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M334.18,343.44c-.09,0-.17-.03-.24-.1-.07-.07-.11-.16-.1-.26.01-.29,1.01-29.15,0-42.45,0-.1.03-.19.09-.26.06-.07.16-.11.25-.11h24.33c.08,0,.16.03.22.08,2.15,1.84,7.02,6.92,5.67,14.28-1.06,5.79-2.9,8.57-4.84,11.5-1.09,1.64-2.22,3.35-3.21,5.65-2.67,6.16-2,9.79-2,9.83.02.1,0,.2-.06.28-.06.08-.15.13-.25.13l-19.84,1.43s-.02,0-.02,0ZM334.55,300.95c.9,12.65.1,38.33-.01,41.78l19.1-1.38c-.11-1.11-.2-4.56,2.09-9.85,1.02-2.36,2.17-4.08,3.27-5.75,1.91-2.88,3.7-5.59,4.74-11.25,1.26-6.9-3.24-11.72-5.35-13.55h-23.84Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M353.94,340.56l-21.1-.46-13.76,8.65h35.38l-.52-8.18Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.46,349.09h-35.38c-.15,0-.29-.1-.33-.25-.04-.15.02-.3.15-.39l13.76-8.65c.06-.04.12-.05.19-.05l21.1.46c.18,0,.32.14.33.32l.52,8.18c0,.09-.03.19-.09.26-.06.07-.16.11-.25.11ZM320.27,348.4h33.82l-.47-7.5-20.68-.45-12.66,7.96Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.9,285.64l1.77,47.14,3.93-.9c3.69-.85,7.56-.44,10.99,1.17h0c3.48,1.63,7.42,2.03,11.16,1.13l5.83-1.4,1.37-7.9c1.37-7.84.67-15.9-2.02-23.4h41.24c14.06,0,25.46-11.4,25.46-25.46l-51.98-1.55-35.62-1.06c-6.82-.2-12.4,5.41-12.14,12.23Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M334.69,285.64c-.24-6.29,4.49-11.55,10.58-12.17l-2.24-.07c-6.82-.2-12.4,5.41-12.14,12.23l1.77,47.14,3.76-.86-1.74-46.27Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.8,334.99c-2.52,0-5.03-.55-7.34-1.62,0,0-.01,0-.02,0-3.34-1.57-7.17-1.97-10.77-1.15l-3.93.9c-.1.02-.2,0-.29-.06-.08-.06-.13-.16-.13-.26l-1.77-47.14c-.13-3.39,1.12-6.59,3.51-9.01,2.39-2.41,5.58-3.68,8.98-3.58l87.6,2.61c.19,0,.33.16.33.34,0,14.23-11.58,25.8-25.8,25.8h-40.76c2.57,7.41,3.22,15.39,1.87,23.11l-1.37,7.9c-.02.14-.13.24-.26.28l-5.83,1.4c-1.32.32-2.68.47-4.03.47ZM347.72,332.73s.01,0,.02,0c3.4,1.59,7.28,1.98,10.93,1.11l5.61-1.34,1.33-7.68c1.35-7.77.66-15.8-2-23.22-.04-.11-.02-.22.04-.31s.17-.15.28-.15h41.24c13.74,0,24.93-11.09,25.11-24.78l-87.26-2.6c-3.2-.09-6.21,1.11-8.47,3.38-2.26,2.28-3.44,5.29-3.32,8.5h0l1.76,46.72,3.52-.81c3.74-.86,7.72-.44,11.2,1.19Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M367.86,319.48c.13,2.63-.14,9.62-6.3,13.64-7.69,5.02-11.41,3.55-17.92,5.92-6.5,2.37-8.67,5.44-8.67,5.44l-8.51-14.91s15.57-17.73,24.64-27.74l16.75,17.66Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M354.17,305.05c-9.08,10.02-24.64,27.74-24.64,27.74l6.2,10.86c-.52.51-.75.83-.75.83l-8.51-14.91s15.57-17.73,24.64-27.74l3.06,3.22Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M334.98,344.83s-.01,0-.02,0c-.12,0-.22-.07-.28-.17l-8.51-14.91c-.07-.13-.06-.29.04-.4.16-.18,15.67-17.84,24.65-27.75.06-.07.15-.11.25-.11h0c.09,0,.18.04.25.11l16.75,17.66c.06.06.09.14.09.22.14,2.83-.2,9.86-6.45,13.94-4.93,3.22-8.21,3.79-11.68,4.4-1.94.34-3.95.69-6.31,1.56-6.3,2.3-8.48,5.28-8.5,5.31-.06.09-.17.14-.28.14ZM326.89,329.61l8.14,14.27c.83-.93,3.29-3.25,8.5-5.16,2.41-.88,4.45-1.24,6.43-1.59,3.4-.6,6.61-1.16,11.42-4.3,5.87-3.83,6.27-10.42,6.15-13.21l-16.4-17.29c-8.51,9.4-22.56,25.39-24.23,27.28Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M338.23,341.98l-11.77-12.41-25.05-1.43,28.41,21.81,8.41-7.97Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M329.82,350.3c-.07,0-.15-.02-.21-.07l-28.41-21.81c-.12-.09-.17-.25-.11-.39.05-.14.2-.23.34-.22l25.05,1.43c.09,0,.17.04.23.11l11.77,12.41c.13.14.12.36-.01.49l-8.41,7.97c-.07.06-.15.09-.24.09ZM302.5,328.55l27.3,20.95,7.95-7.54-11.44-12.06-23.8-1.35Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M430.63,276.02s-54.12-.35-55.02.47c1.18.49-.84,2.96-1.83,3.84l-11.86,10.51-23.44,20.77.11.08c3.97,2.77,6.92,6.72,8.58,11.26,1.56,4.25,4.32,7.94,7.95,10.64l3.6,2.67,8.14-4.7c6.5-3.75,11.9-9.15,15.64-15.66l.23.29s0,.01.01.02c.54.65,31.54-15.5,32.46-16.8,9.07-3.9,15.42-12.9,15.42-23.39Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M380.74,276.49c.46-.42,14.71-.53,28.6-.54-15.26-.01-33.22.07-33.73.54,1.18.49-.84,2.96-1.83,3.84l-11.86,10.51-23.44,20.77.11.08c.54.37,2.68,2.4,3.18,2.82,1.2-.62,25.29-23.66,25.29-23.66l11.86-10.51c.99-.88,3.01-3.35,1.83-3.84Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M358.72,336.62c-.07,0-.14-.02-.2-.07l-3.6-2.67c-3.69-2.74-6.48-6.47-8.07-10.8-1.68-4.57-4.6-8.41-8.46-11.1l-.11-.08c-.09-.06-.14-.16-.14-.26,0-.1.04-.21.12-.28l35.31-31.28c1.03-.92,3.01-3.29,2.89-4.01,0-.04-.02-.06-.06-.07-.11-.05-.19-.14-.21-.26-.02-.12.02-.23.11-.31.9-.83,38.32-.09,54.36.26.19,0,.34.16.34.34,0,10.3-6.11,19.59-15.56,23.68-1.99,1.84-30.83,16.81-32.57,16.88-.17,0-.27-.05-.33-.12-1.57,2.01-9.53,11.98-15.48,15.41l-8.14,4.69c-.05.03-.11.05-.17.05ZM339.02,311.59c3.85,2.76,6.78,6.65,8.47,11.26,1.54,4.2,4.25,7.82,7.83,10.48l3.42,2.54,7.95-4.58c6.37-3.67,15.45-15.45,15.54-15.57.06-.08.16-.13.27-.13.11,0,.2.04.27.13l.15.18c2.47-.54,30.96-15.35,32.02-16.66.03-.04.09-.09.14-.11,9.13-3.93,15.07-12.83,15.21-22.74-19.88-.44-49.13-.89-53.18-.46,0,.02,0,.04.01.06.22,1.34-2.66,4.25-3.11,4.64l-34.98,30.99Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M365.5,264.13c2.33-3.83,3.97-7.03,5.06-9.47.6-1.48,1.13-2.95,1.58-4.35l2.62-10.16-6.72-.11c-2.46-.04-8.17-2.58-8.17-2.58-2.31-1.26-3.29-1.26-5.44-1.23l-3.22,6.35s-1.37,4.11-3,8.05c-.95,2.31-4.25,2.92-5.25,2.55-1.79-.65-6.06.93-6.85,2.16,0,0-4.69.17-7.55,2.58,0,0-2.38-.07-4.02,3.8-1.31,3.1-1.45,10.24,2.1,11.65,2.71,1.08,3.36-2.81,3.36-2.81,0,0,.66,2.05,1.62,2.81,1.71,1.36,4.84,0,4.36-2.36l.68.17c1.82,1.67,3.97,1.38,5.64-.44l.2-.22s2.52,1.06,6.28.81c5.47-.36,10.77-.78,14.2-4.21.59-.85,1.27-1.45,1.86-2.1.23-.29.46-.59.67-.89Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M364.64,239.29c-2.45-.04-8.17-2.58-8.17-2.58-.35-.19-.67-.35-.97-.49,1.48.02,2.49.2,4.38,1.23,0,0,2.41,1.07,4.78,1.83h-.02Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M345.49,270.58c5.42-.36,10.66-.8,14.06-4.2.58-.85,1.27-1.45,1.86-2.1.23-.29.46-.59.68-.89,2.33-3.83,3.97-7.03,5.06-9.47.6-1.48,1.12-2.95,1.58-4.35l2.44-9.48,3.59.06-2.62,10.16c-.46,1.4-.99,2.87-1.58,4.35-1.08,2.44-2.73,5.64-5.06,9.47-.22.3-.45.6-.67.89-.59.66-1.28,1.25-1.86,2.11-3.43,3.42-8.73,3.84-14.2,4.21-1.17.08-2.21.03-3.1-.08-.05-.23-.11-.46-.18-.68Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M333.25,274.25c-.68,0-1.33-.21-1.85-.61-.58-.46-1.05-1.32-1.35-1.99-.25.69-.71,1.55-1.47,1.99-.61.34-1.31.36-2.07.06-1.05-.42-1.86-1.29-2.4-2.61-1.16-2.78-.88-7.15.11-9.49,1.51-3.55,3.64-3.96,4.21-4.01,2.64-2.16,6.62-2.52,7.5-2.57,1.09-1.34,5.33-2.81,7.15-2.15.83.3,3.94-.23,4.82-2.36,1.61-3.88,2.98-7.99,2.99-8.03,0-.02.01-.03.02-.05l3.22-6.35c.06-.11.17-.19.3-.19,2.13-.03,3.2-.04,5.61,1.27.03.01,5.66,2.5,8.01,2.53l6.72.11c.11,0,.2.05.27.14.06.08.09.19.06.29l-2.62,10.16c-.5,1.52-1.03,2.99-1.6,4.39-1.24,2.8-3,6.09-5.08,9.52,0,0,0,.02-.02.02-.22.31-.45.61-.68.9-.2.23-.4.43-.6.64-.42.44-.86.89-1.25,1.45-.01.02-.03.03-.04.05-3.59,3.58-9.09,3.95-14.42,4.3-3.18.21-5.49-.5-6.2-.75l-.04.05c-.94,1.04-2.04,1.61-3.16,1.66-1,.05-2.01-.35-2.89-1.13l-.12-.03c.01.92-.46,1.75-1.33,2.28-.55.34-1.18.51-1.79.51ZM330,270.22c.15,0,.28.1.33.24,0,.02.64,1.96,1.5,2.65.76.6,1.93.63,2.85.06.37-.23,1.21-.89.96-2.08-.02-.12.01-.24.1-.32.08-.08.21-.11.32-.08l.68.17c.06.01.11.04.15.08.76.7,1.62,1.04,2.46,1.01.94-.04,1.87-.54,2.69-1.43l.2-.22c.1-.11.25-.14.39-.09.02.01,2.5,1.03,6.12.79,5.18-.34,10.54-.7,13.95-4.08.41-.6.87-1.06,1.31-1.51.19-.2.39-.4.57-.6.21-.27.43-.56.64-.85,2.07-3.4,3.81-6.66,5.03-9.42.56-1.38,1.09-2.83,1.57-4.32l2.5-9.72-6.28-.11c-2.5-.04-8.07-2.5-8.31-2.61-2.2-1.2-3.16-1.23-5.09-1.2l-3.11,6.14c-.12.35-1.45,4.3-3,8.05-1.04,2.51-4.54,3.16-5.69,2.74-1.71-.61-5.77.97-6.45,2.03-.06.09-.16.15-.28.16-.05,0-4.61.19-7.34,2.5-.06.06-.15.08-.23.08-.09,0-2.18.02-3.69,3.59-.94,2.21-1.21,6.34-.11,8.96.47,1.14,1.16,1.89,2.03,2.24.57.23,1.06.22,1.48-.02,1.08-.61,1.41-2.51,1.42-2.53.03-.16.16-.27.31-.29,0,0,.02,0,.03,0ZM365.5,264.13h0,0Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M330.01,271.53c-.17,0-.32-.12-.34-.3-.03-.24-.81-5.83.02-7.87.07-.18.27-.26.45-.19.18.07.26.27.19.45-.76,1.87.01,7.46.02,7.52.03.19-.1.36-.29.39-.02,0-.03,0-.05,0Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M336.66,271.53c-.07,0-.15-.02-.21-.07-1.41-1.1-1.35-5.14-1.17-9.19.01-.33.03-.63.04-.89,0-.19.17-.34.36-.33.19,0,.34.17.33.36,0,.26-.02.56-.04.89-.11,2.48-.34,7.65.91,8.62.15.12.18.33.06.48-.07.09-.17.13-.27.13Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M342.29,271.08s-.08,0-.13-.02c-.18-.07-.26-.27-.19-.45.84-2.12.29-10.11.29-10.19-.01-.19.13-.35.32-.37.19,0,.35.13.37.32.02.33.56,8.23-.33,10.49-.05.13-.18.22-.32.22Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.57,267.63c-.31,0-.65-.06-1-.18-2.62-.88-4.12-2.7-5.01-3.79-.25-.3-.52-.64-.64-.7-.17-.02-.31-.16-.31-.34,0-.19.15-.34.34-.34.35,0,.63.34,1.13.95.84,1.03,2.26,2.76,4.69,3.58.66.22,1.54.29,2.01-.63,1.06-2.06-.6-7.36-6.39-11.58-.15-.11-.19-.33-.08-.48.11-.15.33-.19.48-.08,6.18,4.5,7.8,10.12,6.6,12.45-.39.75-1.03,1.14-1.84,1.14ZM342.96,262.96h0,0Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M358.2,260.17c-.19,0-.34-.15-.34-.34,0-3.28-4.51-7.25-10.12-7.25-.19,0-.34-.15-.34-.34s.15-.34.34-.34c2.83,0,5.56.94,7.69,2.63,1.95,1.55,3.11,3.53,3.11,5.3,0,.19-.15.34-.34.34Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M423.59,250h25.78l-.63-2.72c-.03-.22-.04-.34-.04-.34,0,0,2.43-.65,2.25-1.91-.32-2.26-2.34-11.21-2.67-12.76-.42-1.95-.9-20.12-15.88-22.7-5.68-.97-18.2-7.93-26.95-10.04-3.95-.96-11.09,1-11.09,1,0,0-16.63,4.22-18.82,4.7-1.91.42-4.64,1.38-7.51,3.1-4.14,2.49-9.61,8.37-10.06,13.48-.16,1.78-3.35,5.15-5.06,8.24-1.94,3.5-2.4,6.62-2.4,6.62l1.36-.15c.86-.1,1.71-.21,2.55-.29,2-.18,3.07.16,5.45,1.23,0,0,5.72,2.54,8.17,2.58l6.72.11s-.78,4.54-2.62,10.16c-.2.92-.71,2.39-1.58,4.35-1.32,3.28-2.99,6.62-5.06,9.47t0,0c-.2.32-.43.6-.67.88-.59.75-1.21,1.46-1.86,2.1h0s-2.29,9.04-2.29,9.04h15.3v-1.43h47.61v-24.73Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M410.14,201.67c.17-.18.35-.35.53-.52-1.82-.66-3.58-1.22-5.21-1.61-3.95-.96-11.09,1-11.09,1,0,0-16.63,4.22-18.82,4.7-1.91.42-4.64,1.37-7.51,3.1-4.14,2.49-9.61,8.37-10.06,13.48-.16,1.78-3.35,5.15-5.06,8.24-1.94,3.5-2.4,6.62-2.4,6.62l1.36-.15c.77-.09,1.53-.19,2.29-.27.36-1.2.95-2.8,1.88-4.49,1.71-3.09,4.9-6.46,5.06-8.24.46-5.11,5.92-10.99,10.06-13.48,2.87-1.72,5.6-2.68,7.51-3.1,2.19-.48,18.82-4.7,18.82-4.7,0,0,7.13-1.96,11.08-1,.5.12,1.02.26,1.55.41Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M423.22,275.07h-28.45c-.19,0-.34-.15-.34-.34v-.4h-33.19c-.11,0-.21-.05-.27-.13s-.09-.19-.06-.3l1.73-6.86c.02-.06.05-.11.09-.16.63-.63,1.25-1.33,1.83-2.08.29-.33.49-.59.65-.85,1.85-2.56,3.54-5.72,5.03-9.42.79-1.79,1.35-3.31,1.57-4.3,1.51-4.62,2.31-8.53,2.55-9.75l-6.31-.11c-2.5-.04-8.07-2.5-8.31-2.61-2.41-1.08-3.39-1.37-5.28-1.2-.53.05-1.07.12-1.6.18-.31.04-.63.08-.94.11l-1.37.15c-.11,0-.21-.03-.28-.1s-.11-.18-.09-.29c.02-.13.49-3.23,2.44-6.74.7-1.27,1.63-2.55,2.52-3.8,1.24-1.72,2.41-3.34,2.5-4.31.49-5.48,6.39-11.44,10.23-13.74,2.45-1.47,5.23-2.62,7.61-3.14,2.16-.47,18.64-4.65,18.81-4.69.29-.08,7.25-1.97,11.25-1,4.53,1.09,10.16,3.51,15.12,5.65,4.67,2.01,9.09,3.91,11.8,4.38,5.84,1.01,10.2,4.44,12.97,10.21,2.21,4.61,2.78,9.41,3.05,11.72.06.48.1.86.14,1.05l.25,1.11c.65,2.91,2.16,9.73,2.43,11.67t0,0c.18,1.28-1.33,1.88-2.22,2.2.07.64-.03,1.26-.16,1.95-.03.16-.17.28-.34.28h-25.02v25.32c0,.19-.15.34-.34.34ZM395.11,274.39h27.77v-25.32c0-.19.15-.34.34-.34h25.08c.11-.62.17-1.16.06-1.69-.03-.17.06-.33.22-.39l.19-.07c.95-.35,1.95-.78,1.86-1.49h0c-.27-1.92-1.78-8.72-2.42-11.62l-.25-1.11c-.05-.22-.09-.59-.15-1.11-.27-2.27-.83-6.99-2.99-11.5-2.66-5.56-6.86-8.86-12.46-9.83-2.8-.48-7.25-2.4-11.96-4.43-4.94-2.13-10.53-4.54-15.01-5.61-3.82-.93-10.84.98-10.91,1-.17.04-16.67,4.23-18.84,4.7-1.1.24-4.01,1.02-7.41,3.06-4.43,2.66-9.48,8.47-9.9,13.22-.1,1.16-1.27,2.77-2.62,4.65-.88,1.23-1.8,2.5-2.48,3.73-1.46,2.64-2.07,5.09-2.27,6.07l.9-.1c.31-.04.62-.07.93-.11.55-.07,1.09-.13,1.62-.18,2.14-.19,3.3.21,5.62,1.26.06.02,5.68,2.51,8.04,2.55l6.72.11c.1,0,.19.05.26.12.06.08.09.18.07.28,0,.05-.8,4.63-2.63,10.21-.22,1-.79,2.57-1.6,4.39-1.51,3.74-3.22,6.96-5.1,9.54-.17.28-.39.56-.7.91-.57.73-1.19,1.43-1.81,2.06l-1.6,6.34h33.09c.19,0,.34.15.34.34v.4Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M374.77,240.5c-.19,0-.34-.15-.34-.34,0-2.82-.86-5.33-1.54-5.33-.19,0-.34-.15-.34-.34s.15-.34.34-.34c1.52,0,2.23,3.59,2.23,6.02,0,.19-.15.34-.34.34Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M425.61,247.92s-.04,0-.06,0l-7.91-1.41c-.16-.03-.28-.16-.28-.32-.14-2.79-.24-5.14-.32-7.12-.22-5.27-.33-7.92-.74-9.31-.05-.18.05-.37.23-.43.18-.05.37.05.43.23.43,1.48.55,4.15.77,9.48.08,1.91.18,4.17.3,6.84l7.65,1.36c.19.03.31.21.28.4-.03.17-.17.28-.34.28Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M374.82,240.6c-.1,0-.32-.04-.39-.38-.03-.16.05-.32.2-.38.11-.44.28-1.42.43-2.24.39-2.24.67-3.74.97-4.19.11-.16.32-.2.48-.09.16.11.2.32.09.48-.24.36-.62,2.5-.87,3.92-.47,2.67-.51,2.87-.91,2.88,0,0,0,0,0,0Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M375.83,259.71c1.66.74,4.16.72,5.51.65.58-.04.94-.08.94-.08,0,0-.02.09-.01.25.02.54.21,1.79,1.76,2.28,1.23.4,2.41-.39,3.16-1.06.46-.43.75-.8.75-.8,0,0,0,.4.05,1.05.18,2.47,1,8.65,4.88,11.37.34.24.7.46,1.08.65,2.42,1.25,5.71,1.74,9.01,1.85,0,.01,0,.02-.01.03.19-.37,4.95.04,5.5.06,2.04.07,4.08.1,6.13.11,3.33,0,6.67.05,10,.07,3.41.02,6.62.65,10.01,1.08,4.38.56,10.23.48,13.36-3.22,2.24-2.64,1.96-6.34,2.15-9.57.1-1.72,0-4.43-.17-7.37-.34-5.81-1.02-8.21-1.17-9.78-.03-.22-.04-.34-.05-.34-.32.07-.64.15-.95.22-.95.21-1.91.4-2.87.56-5.85.98-11.83,1.02-17.72.1l-5.57-.87s.73,5.95.73,5.95l-20.94,1.26s-2.8-3.16-5.49-2.57c-.96.21-1.43.35-1.65.45-.17-.33-.72-.99-2.61-1.58-2.4-.77-3.36.18-3.36.18,0,0-1.53-1.74-3.66-1.9-2.24-.16-10.02,4.45-10.4,8.5-.11,1.24.58,2,1.62,2.48Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M424.31,247.79c-.04-.15-.05-.29-.05-.42l-2.68-.42s.73,5.95.73,5.95l-20.94,1.26s-2.8-3.16-5.49-2.57c-.96.21-1.43.35-1.65.45-.17-.33-.72-.99-2.61-1.58-2.4-.77-3.36.18-3.36.18,0,0-1.53-1.74-3.66-1.9-2.24-.16-10.02,4.45-10.4,8.5-.09.95.31,1.62.96,2.09,1.5-4.14,5.12-6.94,9.49-7.94.98-.23,1.7.35,1.98,1.07,1.06-.48,1.97-.74,2.53-.7,2.13.16,3.66,1.9,3.66,1.9,0,0,.96-.95,3.36-.18,1.88.59,2.14,1.93,2.3,2.26,2.25.86,1.99-.98,2.96-1.19,2.69-.58-.71.61-.71.61l25.49.3s-1.82-7.28-1.91-7.66Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M378.38,260.28s0,.02,0,.02c-.04,0-.07,0-.11-.01.07,0,.11-.01.11-.01Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M423.25,247.82l-1.64-.26c-.03-.39-.04-.62-.03-.62l5.57.87c2.27.35,4.55.55,6.83.62-3.58.14-7.17-.07-10.73-.62Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M383.28,261.75c.46-.43.75-.8.75-.8,0,0,0,.39.05,1.05.02.24.04.53.08.84-.04-.01-.08-.01-.12-.03-.53-.17-.89-.43-1.15-.72.14-.11.28-.22.41-.33Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M437.8,277.87c-2.84,0-5.73-.42-8.59-.83-1.32-.19-2.58-.37-3.82-.51-4.47-.5-9.12-.51-13.61-.52-1.93,0-3.92,0-5.86-.05-.7-.02-1.39-.02-2.09-.02-3.37,0-6.85-.02-10.04-1.61-.38-.19-.74-.41-1.12-.67-3.98-2.8-4.84-9.06-5.03-11.63,0-.08-.01-.15-.01-.22-.06.06-.13.13-.2.2-1.21,1.1-2.42,1.49-3.5,1.13-1.64-.53-1.94-1.83-1.99-2.48-.15.01-.35.03-.57.04-1.7.09-4.06.04-5.67-.68h0c-1.32-.61-1.93-1.56-1.82-2.82.41-4.35,8.44-8.98,10.77-8.81,1.8.13,3.17,1.3,3.68,1.79.47-.27,1.56-.65,3.42-.06,1.56.49,2.3,1.05,2.64,1.49.32-.11.79-.23,1.44-.37,2.57-.56,5.13,1.95,5.71,2.56l20.41-1.23q-.75-5.73-.57-5.88c.08-.07.18-.1.28-.08l5.57.87c5.86.92,11.78.88,17.61-.1,1.02-.17,1.95-.35,2.85-.55.3-.07.59-.14.89-.2h.06s.05-.02.08-.02c.31,0,.35.28.37.51l.02.13c.05.46.13.98.25,1.65.27,1.6.68,4.03.93,8.15.17,2.9.3,8.74.21,10.51-.22,3.68-.65,6.64-4.03,8.42-2.72,1.43-5.64,1.9-8.63,1.9ZM387.93,260.6s.07,0,.11.02c.14.05.23.18.23.32,0,0,0,.39.05,1.03.18,2.47.99,8.49,4.73,11.11.35.24.69.45,1.04.62,3.04,1.52,6.29,1.53,9.73,1.54.7,0,1.4,0,2.11.02,1.94.04,3.92.05,5.84.05,4.51,0,9.18.01,13.69.52,1.26.14,2.57.33,3.84.52,5.74.83,11.69,1.69,16.79-.99,3.07-1.62,3.46-4.27,3.67-7.85.1-1.7-.04-7.58-.21-10.43-.24-4.08-.65-6.48-.92-8.07-.11-.66-.2-1.18-.25-1.64-.2.05-.39.09-.59.13-.91.2-1.85.39-2.89.56-5.9.99-11.9,1.03-17.83.1l-5.14-.8c.11,1.01.45,3.65.69,5.49.01.09-.02.19-.08.26s-.15.12-.24.12l-20.94,1.26c-.1,0-.21-.04-.28-.11-.03-.03-2.7-3-5.16-2.47-1.01.22-1.42.35-1.58.43-.17.08-.37,0-.45-.16-.12-.23-.58-.84-2.4-1.41-2.14-.68-2.98.07-3.02.1-.07.06-.17.1-.25.09-.09,0-.18-.04-.24-.11-.01-.02-1.47-1.64-3.43-1.78-2.05-.13-9.67,4.36-10.03,8.19-.09.97.36,1.65,1.42,2.13,1.49.67,3.73.71,5.35.62.56-.04.91-.08.92-.08.11-.01.22.03.29.11.07.08.11.19.09.29,0,0,0,.07,0,.18.02.56.24,1.55,1.52,1.97,1.05.34,2.11-.35,2.82-.99.43-.4.71-.75.71-.76.07-.09.17-.13.27-.13Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M382.27,260.62c-.19,0-.34-.15-.34-.34,0-.18-.01-4.55,6.11-9.92.14-.13.36-.11.48.03.13.14.11.36-.03.48-5.85,5.14-5.87,9.35-5.87,9.39,0,.19-.15.35-.34.35h0Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M387.93,261.29s-.06,0-.08-.01c-.18-.05-.3-.23-.25-.42.05-.19,1.2-4.66,6.49-8.89.15-.12.36-.09.48.05.12.15.09.36-.05.48-5.09,4.07-6.24,8.48-6.25,8.52-.04.16-.18.26-.33.26Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M390.19,264.7c-.61,0-1.06-.17-1.34-.33-1.04-.58-1.58-1.89-1.23-2.99l.83-2.63c.06-.18.25-.28.43-.22.18.06.28.25.22.43l-.83,2.63c-.22.7.06,1.71.91,2.18,1.44.8,3.69-.35,6.02-3.08l2.6-2.52c.14-.13.35-.13.49,0,.13.14.13.35,0,.49l-2.58,2.5c-2.44,2.86-4.29,3.54-5.51,3.54Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M390.46,264.48c-.08,0-.16-.03-.22-.08-.14-.12-.16-.34-.04-.48,2.25-2.63,2.3-5.03.14-6.95-.13-.12-.29-.26-.2-.49.09-.25.49-.27.62-.06.01.01.03.02.04.04,2.45,2.18,2.43,4.98-.07,7.91-.07.08-.16.12-.26.12Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M428.73,253.84h-16.58c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h16.58c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M384.11,272.11l-49.09.37-10.8-30.64c-.77-2.17.83-4.45,3.14-4.47l41.99-.32c1.43-.01,2.71.89,3.19,2.24l11.56,32.81Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M335.02,272.83c-.15,0-.28-.09-.32-.23l-10.8-30.64c-.4-1.14-.23-2.36.46-3.36.7-.99,1.79-1.56,3-1.57l41.99-.32c1.6,0,2.99.98,3.52,2.47l11.56,32.81c.04.1.02.22-.04.31-.06.09-.17.15-.28.15l-49.09.37h0ZM369.38,237.4h-.02l-41.99.32c-.99,0-1.88.47-2.44,1.28-.57.81-.7,1.8-.38,2.73l10.72,30.41,48.36-.37-11.4-32.36c-.42-1.2-1.56-2.01-2.84-2.01Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M352.31,253.97c-1.16,0-2.1.94-2.1,2.1s.94,2.1,2.1,2.1,2.1-.94,2.1-2.1-.94-2.1-2.1-2.1Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M391.88,275.65l-55.03.42c-.99,0-1.8-.79-1.81-1.78,0-.99.79-1.8,1.79-1.81l55.03-.42c.99,0,1.8.79,1.81,1.78,0,.99-.79,1.8-1.79,1.81Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M336.83,276.42c-.57,0-1.1-.22-1.5-.61-.41-.4-.63-.94-.64-1.51,0-.57.21-1.11.62-1.52.4-.41.94-.64,1.51-.64l55.03-.42c.57,0,1.11.21,1.52.62.41.4.64.94.64,1.51,0,1.18-.94,2.15-2.13,2.16h0l-55.03.42h-.02ZM391.87,272.4h-.01l-55.03.42c-.39,0-.75.16-1.03.43-.27.28-.42.64-.42,1.03,0,.39.16.75.43,1.03.28.27.64.43,1.03.42l55.03-.42c.8,0,1.45-.66,1.44-1.47,0-.39-.16-.75-.43-1.03-.27-.27-.64-.42-1.02-.42ZM391.88,275.65h0,0Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M423.72,211.15c-.11,0-.23-.06-.29-.16-.1-.16-.05-.37.11-.47,2.84-1.78,5.93-2.22,8.96-1.27.18.06.28.25.22.43-.06.18-.25.28-.43.22-2.83-.89-5.72-.48-8.38,1.19-.06.04-.12.05-.18.05Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.71,236.3c-.1,0-.2-.04-.27-.13-.13-.16-3.13-3.99-3.13-6.19,0-.19.15-.34.34-.34s.34.15.34.34c0,1.96,2.95,5.73,2.98,5.76.12.15.09.36-.06.48-.06.05-.14.07-.21.07Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M376.45,226.37c-.19,0-.34-.15-.34-.34v-3.26c0-.19.15-.34.34-.34s.34.15.34.34v3.26c0,.19-.15.34-.34.34Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M409.22,174.91c-.92-.01-1.33,1.22-.58,1.76,1.83,1.3,4.66,3.58,5.49,5.63,1.25,3.1,3.16,2.78,3.34,1.01.18-1.77-3.13-6.51-5.99-7.84-.88-.41-1.63-.55-2.26-.56Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.33,184.98c-.94,0-1.87-.94-2.52-2.56-.81-2-3.71-4.29-5.37-5.48-.46-.33-.64-.91-.46-1.47.18-.56.66-.91,1.23-.91h.02c.76,0,1.57.21,2.4.59,2.96,1.37,6.39,6.26,6.19,8.19-.09.9-.58,1.52-1.28,1.62-.07,0-.13.01-.2.01ZM409.2,175.26c-.32,0-.5.23-.57.44-.07.21-.05.51.21.69,2.1,1.5,4.78,3.72,5.61,5.78.68,1.68,1.49,2.19,1.99,2.12.37-.05.64-.44.7-1.01.16-1.52-2.97-6.18-5.79-7.49-.74-.34-1.46-.52-2.12-.53h0Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M415.83,188.89c.36.47,1,.55,1.43.19.43-.37.5-1.04.14-1.51-.36-.47-1-.55-1.43-.19-.43.37-.5,1.04-.14,1.51Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M416.65,189.65s-.1,0-.15,0c-.37-.04-.71-.23-.94-.54-.46-.61-.38-1.5.19-1.98.28-.23.62-.34.98-.3.37.04.71.23.94.54.46.61.38,1.5-.19,1.98-.24.2-.53.31-.84.31ZM416.59,187.5c-.14,0-.28.05-.4.15-.3.25-.34.72-.09,1.04h0c.12.16.29.25.47.28.17.02.33-.03.47-.14.3-.25.33-.72.09-1.04-.12-.16-.29-.26-.47-.28-.02,0-.05,0-.07,0Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M328.82,273.37c-.19,0-.34-.15-.34-.34,0-2.43-1.7-4-4.33-4-.19,0-.34-.15-.34-.34s.15-.34.34-.34c3.05,0,5.02,1.84,5.02,4.69,0,.19-.15.34-.34.34Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M394.25,206.66c.27,2.3,2.57,3.18,5.4,2.28.34-.11.69-.25,1.05-.41.11-.05.22-.1.33-.16.25-.13.5-.27.74-.41,3.04-1.83,5.19-5.06,4.9-7.53-.17-1.47-1.17-2.37-2.61-2.58-.07-.01-.14-.02-.22-.02-.1-.01-.21-.02-.31-.02-1.07-.04-2.32.25-3.65.91-3.43,1.72-5.96,5.28-5.64,7.94Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M397.57,209.63c-.87,0-1.64-.2-2.26-.6-.8-.51-1.28-1.32-1.4-2.33h0c-.33-2.79,2.29-6.51,5.83-8.29,1.34-.67,2.66-.99,3.81-.95.12,0,.23.01.34.03.06,0,.15,0,.23.02,1.65.25,2.7,1.3,2.89,2.88.3,2.57-1.87,5.95-5.06,7.86-.25.15-.51.29-.77.42l-.33.16c-.4.18-.76.32-1.1.43-.77.25-1.51.37-2.19.37ZM403.33,198.14c-.99,0-2.12.3-3.28.88-3.31,1.66-5.75,5.07-5.46,7.59h0c.09.8.47,1.44,1.09,1.84.92.59,2.33.65,3.87.15.31-.1.65-.23,1.02-.4l.31-.15c.24-.12.49-.26.72-.4,2.97-1.78,5.01-4.87,4.73-7.19-.15-1.27-.97-2.08-2.31-2.28-.06-.01-.12-.02-.18-.02-.12-.01-.21-.02-.31-.02-.07,0-.13,0-.2,0Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M409.21,198.17c-.23.4-.49.81-.76,1.2-.12.17-.25.33-.38.49-.42.53-.85,1.01-1.32,1.46-3.89,3.66-9.41,4.4-13.28,1.45-4.5-3.41-5.06-10.45-1.29-15.74,1.45-2.04,3.34-3.51,5.36-4.36.12-.05.23-.09.35-.13.09-.04.17-.07.26-.1.14-.06.29-.11.43-.15,1.11-.35,2.25-.51,3.37-.47.16,0,.32,0,.48.03.16.02.32.03.48.05.16.03.32.05.48.08,1.05.19,2.07.58,3.01,1.15.26.15.52.33.77.52,4.15,3.14,4.95,9.43,2.05,14.54Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M397.02,204.17c-4.5-3.41-5.06-10.45-1.29-15.74,1.45-2.04,3.34-3.51,5.36-4.36.12-.05.24-.09.35-.13.09-.04.17-.07.26-.1.14-.06.29-.11.43-.15,1.11-.35,2.25-.51,3.37-.47.16,0,.32,0,.48.03.16.01.32.03.48.05.08.01.16.03.25.04-.11-.07-.21-.15-.31-.21-.94-.58-1.96-.96-3.01-1.15-.16-.03-.32-.05-.48-.08-.16-.02-.32-.03-.48-.05-.16-.02-.32-.02-.48-.03-1.12-.04-2.27.12-3.37.47-.14.04-.29.09-.43.15-.09.03-.18.06-.26.1-.11.04-.23.09-.35.13-2.03.85-3.91,2.32-5.36,4.36-3.77,5.29-3.21,12.33,1.29,15.74,1.21.92,2.57,1.48,4,1.7-.15-.1-.3-.19-.45-.3Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M398.97,204.94c-2.05,0-4.03-.63-5.71-1.91h0c-4.63-3.51-5.24-10.78-1.36-16.21,1.44-2.02,3.35-3.57,5.51-4.47l.05-.02c.11-.04.21-.08.32-.12.07-.03.16-.07.26-.1.14-.06.29-.11.44-.16,1.14-.36,2.32-.53,3.49-.48.14,0,.31,0,.5.02l.98.14c1.1.2,2.15.6,3.13,1.19.26.15.53.34.79.54l.12.1c.08.06.16.13.24.2l.11.09c.08.07.16.14.24.21.1.09.22.2.32.31.22.22.41.44.59.65.21.26.4.53.54.74.12.18.22.34.32.52,2.05,3.55,1.92,8.21-.35,12.16-.23.41-.5.83-.78,1.23-.12.16-.24.31-.36.46l-.03.04c-.47.59-.91,1.08-1.35,1.5-.21.2-.42.38-.64.56-2.26,1.86-4.87,2.81-7.38,2.81ZM401.62,182.15c-1,0-1.97.15-2.92.46-.14.04-.27.08-.39.14-.02,0-.03.01-.05.02-.08.02-.14.05-.21.08-.13.05-.22.08-.33.13l-.04.02c-2.03.85-3.84,2.32-5.21,4.24-3.67,5.13-3.12,11.98,1.22,15.26,0,0,0,0,0,0,3.47,2.64,8.38,2.29,12.23-.88.2-.17.41-.35.6-.53.42-.4.84-.87,1.29-1.43l.03-.04c.12-.15.23-.29.34-.44.26-.37.52-.77.74-1.16,2.11-3.69,2.25-8.2.35-11.48-.09-.16-.19-.32-.29-.48-.13-.19-.31-.45-.51-.69-.16-.2-.34-.4-.54-.6-.1-.1-.2-.2-.3-.29-.08-.08-.15-.14-.22-.19l-.12-.1c-.06-.06-.13-.11-.2-.16l-.13-.1c-.24-.18-.48-.35-.72-.49-.91-.55-1.88-.92-2.89-1.1l-.93-.13c-.16-.02-.3-.02-.43-.02-.12,0-.24,0-.36,0Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M409.56,186.35s-.07-.1-.1-.15c-.07-.12-.13-.23-.2-.34-.17-.24-.34-.48-.53-.72-.18-.22-.37-.43-.56-.63-.1-.1-.21-.21-.32-.3-.11-.1-.22-.2-.33-.29-.11-.1-.23-.18-.35-.28-.25-.19-.5-.37-.76-.52-.94-.57-1.96-.95-3.01-1.15-.17-.03-.32-.05-.48-.08-.16-.02-.32-.04-.47-.05-.04,0-.08,0-.12,0,.14-.34.22-.71.22-1.09,0-1.58-1.29-2.87-2.87-2.87s-2.87,1.28-2.87,2.87c0,.79.32,1.51.85,2.03-.95,1.41.77,7.87,5.9,11.12,1.44.92,2.33,4.09,2.58,7.99.21-.18.42-.36.62-.55.47-.45.9-.94,1.32-1.47.13-.16.26-.32.38-.49.27-.39.54-.8.76-1.2,2.22-3.89,2.28-8.47.35-11.82Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M406.13,202.22s-.09,0-.14-.03c-.12-.05-.2-.16-.21-.29-.26-4.04-1.17-6.92-2.42-7.72-3.65-2.31-5.59-6.18-6.14-8.79-.14-.66-.31-1.81,0-2.56-.5-.58-.77-1.31-.77-2.09,0-1.77,1.44-3.21,3.21-3.21s3.21,1.44,3.21,3.21c0,.27-.03.53-.1.79l.67.1c1.12.21,2.17.61,3.13,1.19.26.16.53.34.79.54l.11.09c.09.07.17.13.25.2l.11.09c.08.07.16.13.23.21.1.09.22.2.32.31.22.23.41.44.59.65.21.26.39.52.54.74.05.08.09.15.13.21l.09.15s.05.08.08.12c0,.01.02.02.02.04,2.05,3.55,1.92,8.21-.35,12.16-.22.4-.49.83-.78,1.23-.12.16-.24.31-.36.46l-.03.04c-.48.6-.91,1.08-1.35,1.5-.21.2-.42.38-.64.56-.06.05-.14.08-.22.08ZM399.67,178.21c-1.39,0-2.53,1.13-2.53,2.53,0,.68.26,1.31.75,1.79.12.12.14.3.04.44-.19.28-.3,1.03-.03,2.29.52,2.48,2.36,6.15,5.83,8.35,1.38.88,2.35,3.62,2.69,7.57.03-.03.06-.06.1-.09.42-.4.83-.86,1.29-1.43l.03-.04c.12-.15.23-.29.34-.44.27-.38.52-.78.74-1.16,2.11-3.68,2.25-8.18.36-11.46-.04-.05-.07-.1-.11-.17l-.09-.15c-.04-.06-.07-.12-.11-.18-.15-.22-.32-.45-.5-.68-.16-.19-.34-.39-.54-.6-.09-.1-.2-.2-.3-.29-.08-.07-.14-.13-.21-.19l-.12-.1c-.07-.06-.14-.11-.21-.17l-.12-.09c-.24-.19-.48-.35-.72-.49-.89-.54-1.86-.91-2.9-1.1l-.47-.08-.45-.05c-.06,0-.09,0-.12,0-.11,0-.21-.07-.26-.16s-.07-.21-.02-.31c.13-.31.19-.64.19-.96,0-1.39-1.13-2.53-2.53-2.53Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M394.87,178.68c-1.06,0-1.93.86-1.93,1.92s.86,1.93,1.93,1.93,1.93-.86,1.93-1.93-.86-1.92-1.93-1.92Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M394.87,182.87c-1.25,0-2.27-1.02-2.27-2.27s1.02-2.27,2.27-2.27,2.27,1.02,2.27,2.27-1.02,2.27-2.27,2.27ZM394.87,179.02c-.87,0-1.58.71-1.58,1.58s.71,1.58,1.58,1.58,1.58-.71,1.58-1.58-.71-1.58-1.58-1.58Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M395.25,215.74c-.96,0-1.91-.25-2.77-.76-1.53-.9-2.49-2.47-2.49-4.1,0-.19.15-.34.34-.34s.34.15.34.34c0,1.38.82,2.73,2.15,3.51,1.53.9,3.36.88,5.04-.05.17-.09.38-.03.47.13.09.17.03.37-.13.47-.96.53-1.97.8-2.95.8Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M425.35,285.1c-4.22,0-6.63-3.26-6.63-8.94,0-.19.15-.34.34-.34s.34.15.34.34c0,5.32,2.11,8.25,5.95,8.25.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.86,328.49c-.11,0-.21-.05-.28-.15-.11-.16-.07-.37.08-.48l4.17-2.94c2.07-1.46,3.51-1.86,5.34-2.36,1.93-.53,4.34-1.19,8.53-3.39,6.98-3.66,8.57-7.51,9.74-10.32.18-.43.34-.83.52-1.2.77-1.63,1.88-2,4.33-2.81,1.9-.63,4.78-1.58,9.08-3.68,9.5-4.63,27.3-19.19,27.48-19.34.15-.12.36-.1.48.05s.1.36-.05.48c-.18.15-18.04,14.76-27.62,19.42-4.34,2.11-7.24,3.08-9.16,3.71-2.39.79-3.28,1.09-3.92,2.45-.17.36-.33.75-.5,1.17-1.14,2.75-2.86,6.89-10.05,10.67-4.25,2.23-6.7,2.9-8.66,3.44-1.83.5-3.15.87-5.12,2.26l-4.17,2.94c-.06.04-.13.06-.2.06Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M455.43,301.97c4.03,3.73,2.32,7.46-.71,14.41-3.02,6.95-3.53,32.45-3.53,32.45l2.52-.4s-.4-26.3,3.02-33.36c3.33-7.05,4.84-10.68,7.76-8.36,3.02,2.32-9.07-4.84-9.07-4.84v.1Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M453.21,297.13c.5-2.22,3.43-4.64,7.36-6.65-.6,3.22-2.42,8.57-.5,9.67,2.62,1.51.3-5.95,1.31-10.08,3.73-1.81,8.16-3.33,12.19-4.03h0c-2.32,5.85-5.34,8.16-4.03,9.07.91.71,3.93-6.05,7.96-9.57,3.02-.2,5.54.2,7.05,1.41,2.32,1.81,3.93,3.53,1.51,9.07-1.31,1.01-3.12,1.61-5.14,1.81-5.34.5-7.76.71-4.03,2.52,1.81.91,4.84,0,7.36-.6-.81,1.51-1.81,3.12-3.02,5.04-.81,1.21-1.61,2.22-2.52,3.12-1.71.3-3.22.3-4.03,0-2.52-1.11-8.87-4.43-10.48-3.02s11.79,2.32,10.88,5.85c-6.45,3.73-13.91,1.91-15.22-1.51-1.71-4.64-8.26-5.74-6.75-12.29l.1.2Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M466.61,322.32c-7.05-5.34-14.41-.4-18.14,5.34-3.73,5.64-1.11,18.44-1.11,18.44,0,0,1.41,0,1.41-.5s-3.93-15.12,5.34-21.67c5.74-4.13,9.98-2.12,10.48-.2.5,1.91-2.32,5.54-2.32,5.54l4.23-6.95h.1Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M450.29,311.44c7.05,0,9.37,10.98,7.46,17.43-1.91,6.35-4.64,18.24-4.64,18.24l-1.81-1.81s6.75-16.63,5.14-24.09c-1.61-7.46-5.54-8.67-6.25-8.67s0-1.11,0-1.11h.1Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M456.23,328.87c.5-.71,1.11-1.21,1.91-1.61,0,.5-.2,1.01-.4,1.51-.91,2.92-1.91,6.95-2.82,10.48,0-.5-.2-1.11-.4-2.22,0-.3,0-.5-.1-.81.71-2.32,1.31-4.94,1.81-7.36h0Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M458.15,328.87c13.5-5.64,6.35-13.5,18.24-8.36.81.4,1.81,1.31,2.92,2.52-1.11.3-2.32.5-3.73.3-3.53-.5-2.32,2.32,3.53,3.02,1.11.1,2.02.3,2.72.6,2.82,5.34,4.03,12.4-1.81,14.81-1.21.5-2.62.81-4.23.91-1.81-1.41.4-9.78-2.32-8.67-2.72,1.11.81,7.16.4,8.67-2.62,0-5.64-.5-8.47-1.21-1.11-.6-1.91-1.51-2.22-2.52-.91-3.73,4.94-6.05,5.14-9.27.2-2.92-2.12,6.45-8.26,7.86-5.54-2.62-8.16-6.05-1.81-8.77l-.1.1Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M448.57,318.9c1.41-3.02-2.32-3.73-2.12-1.41.2,2.02.2,7.05-1.91,8.36-3.63-.4-8.57-1.81-12.29-4.03,0-.3,0-.6.2-.91,1.61-3.22,11.89-5.85,8.67-6.95-2.52-.81-6.95,4.13-10.58,6.65-2.12-1.61-3.63-3.63-3.63-5.74s3.63-6.25,8.16-7.86c2.12.2,4.03,1.31,7.05,3.02,4.43,2.52,3.43-1.51-.81-4.03,3.63.2,7.26,1.71,9.98,5.44,0,0-.3,1.61,1.41,4.03,4.64,6.75-.71,10.68-7.05,10.38.4-1.81,1.81-4.94,2.82-7.05l.1.1Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M466.21,322.02c3.43,2.72,7.36,5.85,12.09,7.96,4.74,2.12,3.83,9.07,3.83,9.07,0,0,.71-5.95-3.22-8.06-3.93-2.02-6.55-4.53-9.57-4.94-3.02-.5-4.64-.91-4.64-.91,0,0,.91-1.91.4-2.62-.5-.71,1.21-.4,1.21-.4l-.1-.1Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M483.24,290.58c-12.7,3.43-21.97,11.49-23.78,13.5-1.71,2.02-1.71,2.52-1.71,2.52l1.31,2.52.6-.3s-1.01-2.12,1.61-4.94c4.64-4.74,10.28-8.57,14.11-10.18,3.83-1.61,7.76-3.12,7.76-3.12h.1Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M450.59,360.82h0c-4.74,0-8.67-3.93-8.67-8.67v-8.77h17.33v8.77c0,4.74-3.93,8.67-8.67,8.67Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 442.02,
    y: 345.5,
    width: 17.33,
    height: 1.21
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 442.02,
    y: 347.72,
    width: 17.33,
    height: 0.71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItGovernance);
export default __webpack_public_path__ + "static/media/it-governance.4e76646493ea41c244be40349a40b9d8.svg";
export { ForwardRef as ReactComponent };